<template>
  <div style="height: 100%">
    <!-- 搜素框 -->
    <div style="float: right">
      <el-button
        v-show="
          !isDetailEditMode &&
          authorization('/home-admin/order/order-manage/wasInstallExamine') &&
          tableData.status === 3
        "
        type="success"
        @click="examines()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        >审核</el-button
      >
      <el-button
        v-show="
          !isDetailEditMode &&
          authorization('/home-admin/order/order-manage/preExamine') &&
          tableData.status === 15
        "
        type="success"
        @click="examines()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        >审核</el-button
      >
      <!--      scrollToDiv()    )-->
      <el-button
        type="warning"
        @click="openCompleteDialog()"
        :loading="imgDownloadLoading"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="authorization('/home-admin/order/order-manage/completeOrder')"
        >完成安装</el-button
      >

      <!-- 对话框 -->
      <el-dialog
        title="填写信息"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <!-- 表单 -->
        <el-form
          ref="form"
          :model="completeInstallForm"
          :rules="rulesX"
          label-width="100px"
        >
          <!-- 使用 el-date-picker 替代 el-input 实现日期时间选择 -->
          <el-form-item label="完工时间" prop="completeTimeX">
            <el-date-picker
              v-model="completeInstallForm.completeTimeX"
              type="datetime"
              placeholder="选择完工时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="详细地址" prop="detailAddressX">
            <el-input v-model="completeInstallForm.detailAddressX"></el-input>
          </el-form-item>
        </el-form>

        <!-- 对话框的操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </span>
      </el-dialog>

      <el-button
        type="success"
        @click="download()"
        :loading="imgDownloadLoading"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="
          !isDetailEditMode && authorization('/home-admin/order/order-manage/download')
        "
        >下载图片</el-button
      >

      <el-button
        type="primary"
        @click="editDetail()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="
          !isDetailEditMode && authorization('/home-admin/order/order-manage/download')
        "
        >修改</el-button
      >
      <el-button
        type="success"
        @click="saveEditdDetail()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="
          isDetailEditMode && authorization('/home-admin/order/order-manage/download')
        "
        >保存</el-button
      >
      <el-button
        type="danger"
        @click="cancelEditDetail()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="
          isDetailEditMode && authorization('/home-admin/order/order-manage/download')
        "
        >取消</el-button
      >

      <el-button
        type="primary"
        @click="downloadVideo()"
        :loading="imgDownloadLoading"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="
          !isDetailEditMode && authorization('/home-admin/order/order-manage/download')
        "
        >下载视频</el-button
      >
      <el-button
        type="info"
        @click="goback()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="!isDetailEditMode"
        >返回</el-button
      >
    </div>
    <el-descriptions
      title="订单详情"
      :column="4"
      border
      size="mini"
      :labelStyle="{ width: '8%' }"
      :contentStyle="{ width: '17%' }"
      style="
        background-color: #fff;
        padding: 20px;
        padding-bottom: 0;
        border-radius: 8px;
        border-top-left-radius: 0%;
        border-top-right-radius: 0%;
      "
    >
      <el-descriptions-item label="投诉单号" v-if="$route.query.isRepairOrder">{{
        tableData.reserve5
      }}</el-descriptions-item>
      <el-descriptions-item label="问题来源" v-if="$route.query.isRepairOrder">{{
        tableData.sourceOrderIdStr
      }}</el-descriptions-item>
      <el-descriptions-item label="主机厂质保" v-if="$route.query.isRepairOrder">{{
        tableData.oemWarranty
      }}</el-descriptions-item>
      <el-descriptions-item label="是否有责" v-if="$route.query.isRepairOrder">
        <el-select
          v-if="isDetailEditMode"
          v-model="editTime.isResponsible"
          placeholder="请选择是否有责"
          style="width: 100%"
        >
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
        <span v-else>{{ tableData.isResponsibleStr }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="订单编号">{{
        tableData.orderNum
      }}</el-descriptions-item>
            <el-descriptions-item label="所属公司">{{
        tableData.companyName
      }}</el-descriptions-item>
            <el-descriptions-item label="所属区域">{{
        tableData.regionName
      }}</el-descriptions-item>
     <el-descriptions-item label="订单类型">{{
        orderTypeFormat(tableData)
      }}</el-descriptions-item>
      <el-descriptions-item label="充电桩类型">{{
        tableData.storeName
      }}</el-descriptions-item>
      <el-descriptions-item  label="套包信息">{{
        tableData.packageInfo || "-"
      }}</el-descriptions-item>
      <el-descriptions-item label="品牌">{{
        tableData.deviceBrandName
      }}</el-descriptions-item>
      <el-descriptions-item label="车型">{{ tableData.modelName }}</el-descriptions-item>


 
      <el-descriptions-item label="维修类型" v-if="tableData.orderType === 2">{{
        repairTypeFormat(tableData)
      }}</el-descriptions-item>
      <el-descriptions-item label="原订单编号" v-if="tableData.orderType === 2">{{
        tableData.oldOrderNum
      }}</el-descriptions-item>
      <el-descriptions-item label="故障描述" v-if="tableData.orderType === 2">{{
        tableData.faultDescription
      }}</el-descriptions-item>
      <el-descriptions-item label="客户名">{{
        tableData.customerName
      }}</el-descriptions-item>
      <el-descriptions-item label="客户电话">{{
        tableData.phone
      }}</el-descriptions-item>
      <el-descriptions-item label="安装联系人">{{
        tableData.installerInfo || "-"
      }}</el-descriptions-item>
      <el-descriptions-item label="安装联系人电话">{{
        tableData.installerPhone || "-"
      }}</el-descriptions-item>
      <el-descriptions-item label="主机厂订单号">{{
        tableData.pileModel
      }}</el-descriptions-item>
      <el-descriptions-item label="上游订单号">{{
        tableData.reserve2
      }}</el-descriptions-item>
      <el-descriptions-item label="车架号">{{ tableData.frameNo }}</el-descriptions-item>
      <el-descriptions-item label="订单金额">{{ tableData.price }}</el-descriptions-item>
      <el-descriptions-item label="负责师傅">{{
        tableData.masterWorkerName
      }}</el-descriptions-item>

      <el-descriptions-item label="完工时间" class="center-content">
        <el-date-picker
          v-if="isDetailEditMode"
          v-model="editTime.installTime"
          type="datetime"
          placeholder="选择日期时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="custom-date-picker"
          size="mini"
        >
        </el-date-picker>

        <span v-if="!isDetailEditMode" class="install-time-text">
          {{ dateFormat(tableData.installTime) }}
        </span>
      </el-descriptions-item>

      <el-descriptions-item label="完工提交时间">{{
        dateFormat(tableData.installFinishTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="录单人">{{
        tableData.recordUserName
      }}</el-descriptions-item>
      <el-descriptions-item label="录单时间">{{
        dateFormat(tableData.recordTime)
      }}</el-descriptions-item>

      <el-descriptions-item label="预约时间">
        <el-date-picker
          v-if="isDetailEditMode"
          v-model="editTime.subscribeTime"
          type="datetime"
          placeholder="选择日期时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="custom-date-picker"
          size="mini"
        >
        </el-date-picker>
        <span v-if="!isDetailEditMode" class="install-time-text">
          {{ dateFormat(tableData.subscribeTime) }}
        </span>
      </el-descriptions-item>

      <el-descriptions-item label="是否带桩">
        <el-select
          v-if="isDetailEditMode"
          v-model="editTime.isDockingRequired"
          placeholder="请选择是否带桩"
          style="width: 100%"
        >
          <el-option :label="'是'" :value="true"></el-option>
          <el-option :label="'否'" :value="false"></el-option>
        </el-select>
        <span v-else>{{ tableData.isDockingRequired ? "是" : "否" }}</span>
      </el-descriptions-item>
       
            <el-descriptions-item label="交车日期">{{
        tableData.deliveryDate || "-"
      }}</el-descriptions-item>
    <el-descriptions-item label="住宅类型">{{
        houseTypeFormat(tableData)
      }}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      :column="4"
      border
      size="mini"
     :labelStyle="{ width: '8%' }"
      :contentStyle="{ width: '17%' }"
      style="
        background-color: #fff;
        padding: 20px;
        padding-top: 5px;
        border-radius: 8px;
        border-top-left-radius: 0%;
        border-top-right-radius: 0%;
      "
    >
      <el-descriptions-item label="省">{{
        tableData.provinceName || "-"
      }}</el-descriptions-item>
      <el-descriptions-item label="市">{{
        tableData.cityName || "-"
      }}</el-descriptions-item>
      <el-descriptions-item label="区县">{{
        tableData.areaName || "-"
      }}</el-descriptions-item>
      <el-descriptions-item span="7" label="详细地址">
        <el-input
          v-if="isDetailEditMode"
          v-model="editTime.detailAddress"
          placeholder="请输入详细地址"
        />
        <span v-else>{{ tableData.detailAddress }}</span>
      </el-descriptions-item>

      <el-descriptions-item span="7" label="订单备注">{{
        tableData.orderRemark
      }}</el-descriptions-item>
      <el-descriptions-item span="7" label="跟进备注" v-if="false">
        <div
          v-for="(item, index) in getFollowRemarkList(tableData.followRemark)"
          style="width: 100%; text-align: left; margin: 0"
          :key="index"
        >
          {{ item }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item span="7" label="驳回理由">{{
        tableData.rejectRemark
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 跟进详情 -->
    <div style="float: right">
      <el-button
        type="success"
        @click="addFollow()"
        size="mini"
        style="margin-top: 20px; margin-right: 20px"
        v-show="authorization('/home-admin/order/order-manage/addFollow')"
        >新增</el-button
      >
    </div>
    <el-descriptions
      title="跟进详情"
      :column="3"
      border
      :labelStyle="{ width: '8%' }"
      :contentStyle="{ width: '17%' }"
      style="margin-top: 15px; background-color: #fff; padding: 20px; border-radius: 8px"
      size="mini"
    >
      <template v-for="(item, index) in modelTableData">
        <el-descriptions-item :key="`followTime-${index}`" label="跟进时间">
          {{ dateFormat(item.followTime) }}
        </el-descriptions-item>
        <el-descriptions-item :key="`followerName-${index}`" label="跟进人">
          {{ item.followerName }}
        </el-descriptions-item>
        <el-descriptions-item :key="`followInfo-${index}`" label="跟进备注">
          {{ item.followInfo }}
        </el-descriptions-item>
      </template>
    </el-descriptions>
    <!-- 充电桩详情 -->
    <el-descriptions
      title="充电桩详情"
      :column="4"
      border
      :labelStyle="{ width: '8%' }"
      :contentStyle="{ width: '17%' }"
      style="margin-top: 15px; background-color: #fff; padding: 20px; border-radius: 8px"
      size="mini"
    >
      <template slot="extra">
        <el-button
          type="primary"
          size="small"
          @click="deviceUpdate"
          v-show="
            !deviceUpdateClick &&
            authorization('/home-admin/order/order-manage/edit') &&
            (tableData.orderType !== 2 ||
              (tableData.orderType == 2 && tableData.repairType === 1))
          "
          >修改</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="saveUpdate"
          v-show="
            deviceUpdateClick && authorization('/home-admin/order/order-manage/edit')
          "
          >保存</el-button
        >
        <el-button
          type="danger"
          size="small"
          @click="deviceUpdateCancle"
          v-show="
            deviceUpdateClick && authorization('/home-admin/order/order-manage/edit')
          "
          >取消</el-button
        >
        <el-button
          type="warning"
          size="small"
          @click="unbindDevice"
          v-show="
            !deviceUpdateClick &&
            authorization('/home-admin/order/order-manage/edit') &&
            tableData.deviceId
          "
          >解绑充电桩</el-button
        >
      </template>

      <el-descriptions-item label="充电桩编号">
        <el-select
          v-if="deviceUpdateClick"
          v-model="tableData.deviceNum"
          placeholder="请选择充电桩编号或手动输入"
          size="small"
          style="width: 100%"
          filterable
          default-first-option
        >
          <!-- 遍历 deviceNums 数组生成每个充电桩编号的选项 -->
          <el-option
            v-for="item in deviceListX"
            :key="item.deviceNum"
            :label="item.deviceNum"
            :value="item.deviceNum"
          ></el-option>
        </el-select>
        <span v-else>{{ tableData.deviceNum }}</span>
      </el-descriptions-item>

      <el-descriptions-item label="充电桩类型">
        <el-select
          v-if="deviceUpdateClick"
          filterable
          v-model="tableData.storeId"
          placeholder="请选择充电桩类型"
          @change="$forceUpdate()"
          style="width: 100%"
        >
          <el-option
            v-for="item in deviceCategoryList"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
        <span v-else>{{ tableData.storeName }}</span>
      </el-descriptions-item>
      <!-- <el-descriptions-item label="是否自提桩">{{ tableData.isSelfPickup
        == '1' ? "是" : "否" }}</el-descriptions-item> -->
      <el-descriptions-item label="电源点来源">
        <el-select
          v-if="deviceUpdateClick"
          :disabled="tableData.orderType == 3"
          filterable
          v-model="tableData.powerSource"
          placeholder="请选择充电源来源"
          @change="$forceUpdate()"
          style="width: 100%"
        >
          <el-option
            v-for="item in powerSourceCol"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <span v-else>{{ tableData.powerSource }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="电缆品牌">
        <div v-if="deviceUpdateClick">
          <el-select
            filterable
            v-model="tableData.cableBrandId"
            :disabled="tableData.orderType == 3"
            placeholder="请选择电缆品牌"
            @change="$forceUpdate()"
            :style="tableData.cableBrandId === -1 ? 'width: 50%' : 'width: 100%'"
          >
            <el-option
              v-for="item in cableBrandCol"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            size="small"
            style="width: 50%; height: 100%"
            v-show="deviceUpdateClick && tableData.cableBrandId === -1"
            v-model="tableData.cableBrandName"
          ></el-input>
        </div>
        <span v-else>{{ tableData.cableBrandName }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="用线长度">
        <el-input-number
          size="small"
          v-if="deviceUpdateClick"
          style="width: 100%"
          v-model="tableData.lineLength"
          :disabled="tableData.orderType == 3"
        ></el-input-number>
        <span v-else>{{ tableData.lineLength }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="增项费用">
        <el-input-number
          size="small"
          v-if="deviceUpdateClick"
          style="width: 100%"
          v-model="tableData.addOutlay"
          :disabled="tableData.orderType == 3"
        ></el-input-number>
        <span v-else>{{ tableData.addOutlay }}</span>
      </el-descriptions-item>
      <!-- <el-descriptions-item label="是否购买延长线">
        <el-select
          v-if="deviceUpdateClick"
          :disabled="tableData.orderType == 3"
          filterable
          v-model="tableData.purchaseExtension"
          placeholder="请选择是否购买延长线"
          @change="$forceUpdate()"
          style="width: 100%"
        >
          <el-option
            v-for="item in choiceList2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span v-else>{{ tableData.purchaseExtension === 1 ? "已购买" : "未购买" }}</span>
      </el-descriptions-item> -->
      <el-descriptions-item label="前端线材">
        <el-select
          v-if="deviceUpdateClick"
          :disabled="tableData.orderType == 3"
          filterable
          v-model="tableData.frontEndCable"
          placeholder="请选择前端线材"
          @change="$forceUpdate()"
          style="width: 100%"
        >
          <el-option
            v-for="item in frontEndCableOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span v-else>{{ valueByKey(tableData.frontEndCable, frontEndCableOptions) }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="是否签免责">
        <el-select
          v-if="deviceUpdateClick"
          :disabled="tableData.orderType == 3"
          filterable
          v-model="tableData.signExemption"
          placeholder="请选择是否签免责"
          @change="$forceUpdate()"
          style="width: 100%"
        >
          <el-option
            v-for="item in choiceList1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span v-else>{{ tableData.signExemption === 1 ? "已签" : "未签" }}</span>
      </el-descriptions-item>

      <el-descriptions-item label="是否自布线">
        <el-select
          v-if="deviceUpdateClick"
          :disabled="tableData.orderType == 3"
          filterable
          v-model="tableData.isWiring"
          placeholder="请选择是否自布线"
          @change="$forceUpdate()"
          style="width: 100%"
        >
          <el-option
            v-for="item in choiceListX"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span v-else>{{ tableData.isWiring ? "是" : "否" }}</span>
      </el-descriptions-item>

      <el-descriptions-item label="选择住宅类型">
        <el-select
          v-if="deviceUpdateClick"
          v-model="tableData.houseType"
          placeholder="请选择住宅类型"
          style="width: 100%"
          :disabled="tableData.orderType === 3"
        >
          <el-option
            v-for="item in houseTypeList"
            :key="item.id"
            :label="item.houseTypeName"
            :value="item.id"
          ></el-option>
        </el-select>
        <span v-else>{{ getHouseTypeName(tableData.houseType) }}</span>
      </el-descriptions-item>
    </el-descriptions>
    <!-- 图片 -->
    <el-card
      style="margin-top: 15px; border-radius: 8px"
      :body-style="{ padding: '0px' }"
    >
      <div slot="header" class="clearfix" ref="targetDiv">
        <span><strong>图片信息</strong></span>
        <div style="float: right">
          <el-button
            type="primary"
            size="small"
            @click="handleImageUpdate"
            v-show="authorization('/home-admin/order/order-manage/editImage')"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="handleImageReset"
            v-show="authorization('/home-admin/order/order-manage/resetImage')"
            >重置图片模板</el-button
          >
        </div>
      </div>
      <el-descriptions
        direction="vertical"
        :column="8"
        border
        size="mini"
        style="background-color: #fff; padding: 10px"
      >
        <template v-for="img in templateDetailList">
          <el-descriptions-item
            :key="img.id"
            :label="img.imageName"
            :labelStyle="
              templateDetailList.indexOf(img) === templateDetailList.length - 1
                ? ''
                : { width: '12.5%' }
            "
            :contentStyle="{ height: '200px' }"
          >
            <div style="position: relative; display: inline-block;">
              <el-image
                :src="getFirstImageUrl(img.miniUrl)"
                style="height: 200px; cursor: pointer;"
                v-show="img.miniUrl !== null && img.miniUrl != ''"
                @click="openImagePreview(img)"
              ></el-image>
              <div
                v-if="getImageCount(img.url) > 1"
                style="
                  position: absolute;
                  top: 5px;
                  right: 5px;
                  background-color: rgba(0, 0, 0, 0.6);
                  color: white;
                  padding: 4px 8px;
                  border-radius: 4px;
                  font-size: 12px;
                  font-weight: bold;
                "
              >
                {{ getImageCount(img.url) }}张
              </div>
            </div>
          </el-descriptions-item>
        </template>
      </el-descriptions>

      <el-descriptions
        direction="vertical"
        border
        size="mini"
        style="
          background-color: #fff;
          padding: 0 10px 10px 10px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <el-descriptions-item
          label="免责图"
          labelStyle="width: 12.5%;"
          contentStyle="height:200px"
        >
          <div>
            <el-image
              v-for="(item, index) in reserve3List"
              :key="index"
              :src="item"
              style="height: 200px; width: 13%; margin-right: 5px; float: left; cursor: pointer;"
              @click="openImagePreviewFromList(reserve3List, index)"
            ></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        direction="vertical"
        border
        size="mini"
        style="
          background-color: #fff;
          padding: 0 10px 10px 10px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <el-descriptions-item
          label="勘测确认图"
          labelStyle="width: 87.5%;"
          contentStyle="height:200px"
        >
          <div>
            <el-image
              v-for="(item, index) in surveyImageList"
              :key="index"
              :src="item"
              style="height: 200px; width: 13%; margin-right: 5px; float: left; cursor: pointer;"
              @click="openImagePreviewFromList(surveyImageList, index)"
            ></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        direction="vertical"
        border
        size="mini"
        v-show="courierImageList != null && courierImageList.length > 0"
        style="
          background-color: #fff;
          padding: 0 10px 10px 10px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <el-descriptions-item
          label="快递单据图"
          labelStyle="width: 100%;"
          contentStyle="height:200px"
        >
          <el-image
            :src="
              courierImageList != null && courierImageList.length > 0
                ? courierImageList[0]
                : ''
            "
            :preview-src-list="courierImageList"
            v-show="courierImageList != null && courierImageList.length > 0"
            style="height: 200px; width: 13%; margin-right: 5px; float: left"
          ></el-image>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        direction="vertical"
        border
        size="mini"
        style="
          background-color: #fff;
          padding: 0 10px 10px 10px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <el-descriptions-item
          label="其他多图"
          labelStyle="width: 100%;"
          contentStyle="height:200px"
        >
          <div style="overflow: auto; height: 210px">
            <el-image
              v-for="(item, index) in otherImgList"
              :key="index"
              :src="item"
              style="height: 200px; width: 13%; margin-right: 5px; float: left; cursor: pointer;"
              @click="openImagePreviewFromList(otherImgList, index)"
            ></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        direction="vertical"
        border
        size="mini"
        style="
          background-color: #fff;
          padding: 0 10px 10px 10px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <el-descriptions-item
          label="相关视频"
          labelStyle="width: 100%;"
          contentStyle="height:200px"
        >
          <video
            width="100%"
            type="video/mp4"
            v-show="tableData.videoUrl != null && tableData.videoUrl != ''"
            :src="changeImageUrl(tableData.videoUrl)"
            style="height: 200px; width: 300px"
            muted="muted"
            preload="preload"
            controls="controls"
          ></video>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- 订单物料相关 -->
    <div
      style="
        height: 400px;
        overflow: auto;
        background-color: #fff;
        border-radius: 8px;
        padding: 5px 20px 20px 20px;
        margin-top: 15px;
        margin-bottom: 50px;
      "
    >
      <div style="width: 100%; height: 50px; line-height: 50px">
        <strong>订单物料相关</strong>
        <el-button
          style="float: right; margin-top: 5px"
          type="primary"
          size="small"
          @click="addMaterial"
          v-show="authorization('/home-admin/order/order-manage/addMaterial')"
          >添加</el-button
        >
      </div>
      <el-table
        size="mini"
        :summary-method="getSummaries"
        show-summary
        :data="materialOrderList"
        stripe
        :header-cell-style="{ background: 'rgba(132,170,206,0.29)', color: '#343333' }"
        height="350px"
        width="100%"
        ref="tableData"
        :border="true"
      >
        <el-table-column
          prop="modelName"
          label="物料型号"
          width="300px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="typeName"
          label="物料类型"
          align="center"
        ></el-table-column>
        <el-table-column prop="meterialPrice" label="单价" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-if="isEdit[scope.$index]"
              size="mini"
              clearable
              style="width: 100%"
              v-model.trim="scope.row.meterialPrice"
              @change="calcTotal(scope.row)"
              :min="0"
            />
            <span v-if="!isEdit[scope.$index]">{{ scope.row.meterialPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="耗材量" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-if="isEdit[scope.$index]"
              size="mini"
              clearable
              style="width: 100%"
              v-model.trim="scope.row.num"
              @change="calcTotal(scope.row)"
              :min="0"
            />
            <span v-if="!isEdit[scope.$index]">{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="allPrice" label="总价" align="center"></el-table-column>
        <el-table-column prop="actualAmount" label="实收金额" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-if="isEdit[scope.$index]"
              size="mini"
              clearable
              style="width: 100%"
              v-model.trim="scope.row.actualAmount"
              :min="0"
            />
            <span v-if="!isEdit[scope.$index]">{{ scope.row.actualAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="保存"
              placement="top-end"
              v-if="
                isEdit[scope.$index] &&
                authorization('/home-admin/order/order-manage/editMaterial')
              "
            >
              <el-button
                type="success"
                icon="el-icon-check"
                circle
                size="mini"
                @click="updateMaterialSumbit(scope)"
                style="margin-left: 10px"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top-end"
              v-if="
                !isEdit[scope.$index] &&
                authorization('/home-admin/order/order-manage/editMaterial')
              "
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                size="mini"
                @click="updateMaterial(scope.$index)"
                style="margin-left: 10px"
              ></el-button>
            </el-tooltip>

            <el-tooltip effect="dark" content="删除" placement="top-end">
              <el-popconfirm title="确认删除吗？" @confirm="deleteMaterial(scope.row)">
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                  style="margin-left: 10px"
                  v-show="authorization('/home-admin/order/order-manage/delMaterial')"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--        <el-table-column prop="remarks" label="备注"></el-table-column>-->
      </el-table>
    </div>

    <el-dialog
      title="修改图片"
      :visible.sync="dialogUpdateImage"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="imageUpdateParams"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <div v-for="img in imageUpdateParams.templateDetailList" v-bind:key="img.key">
          <el-form-item :label="img.imageName">
            <el-upload
              action="#"
              accept="image/jpeg,image/png,image/tiff,image/vnd.svf"
              :file-list="img.imgList"
              list-type="picture-card"
              :auto-upload="false"
              :multiple="true"
              :limit="img.maxCount || 10"
              :on-change="(file, fileList) => upload(file, fileList, img.id)"
              :on-remove="(file, fileList) => commRemove(file, fileList, img.id)"
              :on-preview="handlePictureCardPreview"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="免责图" v-show="imageUpdateParams.signExemption === 1">
          <el-upload
            action="#"
            accept="image/jpeg,image/png,image/tiff,image/vnd.svf"
            :file-list="imageUpdateParams.reserve3List"
                :limit=" 10"
                  :multiple="true"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="(file, fileList) => upload(file, fileList, -2)"
            :on-remove="(file, fileList) => commRemove(file, fileList, -2)"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="勘测确认单">
          <el-upload
            action="#"
            accept="image/jpeg,image/png,image/tiff,image/vnd.svf"
            :file-list="imageUpdateParams.surveyImageList"
            list-type="picture-card"
            :auto-upload="false"
             :limit=" 10"
               :multiple="true"
            :on-change="(file, fileList) => upload(file, fileList, -3)"
            :on-remove="(file, fileList) => commRemove(file, fileList, -3)"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="其他图片">
          <el-upload
            action="#"
            accept="image/jpeg,image/png,image/tiff,image/vnd.svf"
            :file-list="imageUpdateParams.reserve1List"
            list-type="picture-card"
            :auto-upload="false"
             :limit=" 10"
               :multiple="true"
            :on-change="(file, fileList) => upload(file, fileList, -1)"
            :on-remove="(file, fileList) => commRemove(file, fileList, -1)"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="相关视频">
          <el-upload
            action="#"
            accept="video/*"
            :file-list="imageUpdateParams.videoList"
            :auto-upload="false"
            :on-change="(file, fileList) => uploadVideo(file, fileList, -99)"
            :on-remove="(file, fileList) => commRemove(file, fileList, -99)"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <video
            v-if="
              imageUpdateParams.videoUrl !== null && imageUpdateParams.videoUrl !== ''
            "
            v-bind:src="changeImageUrl(imageUpdateParams.videoUrl)"
            muted="muted"
            preload="preload"
            controls="controls"
            class="avatar video-avatar"
          ></video>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 60px">
        <el-button type="success" size="mini" @click="saveImageUpdate">确认</el-button>
        <el-button @click="dialogUpdateImage = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="审核"
      :visible.sync="dialogFormExamine"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="examine" label-width="160px" size="small" style="width: 600px">
        <el-form-item label="驳回理由">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            placeholder="请输入驳回理由（通过则不填写）"
            v-model="examine.rejectRemark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 60px">
        <el-popconfirm
          title="确认审核通过吗？"
          @confirm="examineOrder('orderManageArray', 6)"
        >
          <el-button slot="reference" type="success" size="mini">通过</el-button>
        </el-popconfirm>
        <el-popconfirm
          title="确认驳回吗？"
          @confirm="examineOrder('orderManageArray', 4)"
          style="margin-left: 10px"
        >
          <el-button slot="reference" type="danger" size="mini">驳回</el-button>
        </el-popconfirm>
      </div>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="dialogUpdate"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="updateParams"
        label-width="160px"
        size="small"
        style="width: 500px"
      >
        <el-form-item label="充电桩编号">
          <el-input
            placeholder="请输入充电桩编号"
            v-model="updateParams.deviceNum"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 60px">
        <el-button type="success" size="mini" @click="saveUpdate">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加物料"
      :visible.sync="dialogAddMaterial"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addMaterialParams"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="选择物料">
          <el-cascader
            @change="materialChanged"
            v-model="addMaterialParams.modeAndTypeId"
            :options="materialList"
            :props="optionProps"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="单价">
          <el-input
            placeholder="请输入单价"
            type="number"
            v-model="addMaterialParams.meterialPrice"
            @change="calcTotal(addMaterialParams)"
          ></el-input>
        </el-form-item>
        <el-form-item label="耗材量">
          <el-input
            placeholder="请输入耗材量"
            type="number"
            v-model="addMaterialParams.num"
            @change="calcTotal(addMaterialParams)"
          ></el-input>
        </el-form-item>
        <el-form-item label="实收金额">
          <el-input
            placeholder="请输入实收金额"
            type="number"
            v-model="addMaterialParams.actualAmount"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 60px">
        <el-button type="success" size="mini" @click="saveMaterial">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog 
      :visible.sync="dialogImagePreview" 
      :fullscreen="true"
      :close-on-click-modal="true"
      custom-class="image-preview-dialog"
      @opened="onImagePreviewOpened"
      @close="handlePreviewClose"
    >
      <div class="image-preview-body">
        <div class="image-preview-layout">
          <!-- 左侧图片预览区域 -->
          <div class="image-preview-left">
            <div
              v-if="previewImageList.length > 1"
              ref="imagePreviewThumbnails"
              class="image-preview-thumbnails"
            >
              <div class="image-preview-thumbnails-track">
                <div
                  v-for="(item, index) in previewImageList"
                  :key="index"
                  class="image-preview-thumbnail-item"
                  :class="{ 'is-active': thumbnailActiveIndex === index }"
                  @click="switchImage(index)"
                >
                  <img
                    :src="item"
                    alt=""
                    class="image-preview-thumbnail-img"
                  />
                  <div
                    v-if="previewImageMetaList[index]"
                    class="image-preview-thumbnail-meta"
                  >
                    <span class="image-preview-thumbnail-type">{{ previewImageMetaList[index].typeName }}</span>
                    <span class="image-preview-thumbnail-index">
                      {{ previewImageMetaList[index].typeIndex }}/{{ previewImageMetaList[index].typeTotal || 1 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="image-preview-stage">
            <div
              ref="imagePreviewContainer"
              class="image-preview-container"
              @wheel.prevent="handleWheel"
              @mousedown="handleMouseDown"
              @mousemove="handleMouseMove"
              @mouseup="handleMouseUp"
              @mouseleave="handleMouseUp"
              @dblclick="handleDoubleClick"
            >
          <img
            ref="previewImage"
            decoding="async"
            :src="currentPreviewImage || imagePreviewUrl"
            alt=""
            :style="{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              transform: `rotate(${imageRotate}deg) scale(${imageScale}) translate(${imageTranslateX}px, ${imageTranslateY}px)`,
              transition: isDragging ? 'none' : 'transform 0.3s',
              cursor: imageScale > 1 ? 'move' : 'default'
            }"
          />
          <!-- 图片类型与序号 -->
          <div
            v-if="previewImageList.length > 0"
            class="image-preview-top-bar"
          >
            <div
              v-if="previewImageMetaList.length > 0 && previewImageMetaList[currentPreviewIndex]"
              class="image-preview-type-title"
            >
              {{ formatPreviewTypeTitle(previewImageMetaList[currentPreviewIndex]) }}
            </div>
            <div class="image-preview-counter">
              {{ currentPreviewIndex + 1 }} / {{ previewImageList.length }}
            </div>
          </div>
        <div
          v-if="previewImageList.length > 1"
          class="image-preview-nav-btn image-preview-nav-btn--prev"
          @click.stop="prevImage"
          @dblclick.stop
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <div
          v-if="previewImageList.length > 1"
          class="image-preview-nav-btn image-preview-nav-btn--next"
          @click.stop="nextImage"
          @dblclick.stop
        >
          <i class="el-icon-arrow-right"></i>
        </div>
        <!-- 缩放控制按钮 -->
        <div class="image-preview-zoom-toolbar" @click.stop @dblclick.stop>
          <div class="image-preview-tool-btn" title="放大" @click="zoomIn">+</div>
          <div class="image-preview-tool-btn" title="缩小" @click="zoomOut">−</div>
          <div class="image-preview-tool-btn image-preview-tool-btn--rotate" title="左旋转" @click="rotateLeft">↶</div>
          <div class="image-preview-tool-btn image-preview-tool-btn--rotate" title="右旋转" @click="rotateRight">↷</div>
          <div class="image-preview-tool-btn image-preview-tool-btn--reset" title="还原视图" @click="resetImageZoom">还原</div>
          <div
            class="image-preview-tool-btn image-preview-tool-btn--reset"
            title="复制到剪贴板"
            @click="copyCurrentPreviewImage"
          >复制</div>
          <div
            class="image-preview-tool-btn image-preview-tool-btn--reset"
            title="保存到本地文件夹（按订单编号分类）"
            @click="saveCurrentPreviewImage"
          >保存</div>
        </div>
          </div>
            </div>
        </div>
        <!-- 右侧订单信息展示框 -->
        <div class="image-preview-sidebar">
          <div class="order-info-container">
            <div class="order-info-content">
              <div class="order-info-item">
                <div class="order-info-label">订单编号</div>
                <div class="order-info-value">{{ tableData.orderNum || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">订单状态</div>
                <div class="order-info-value">{{ statusFormat(tableData) || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">订单类型</div>
                <div class="order-info-value">{{ orderTypeFormat(tableData) || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">充电桩类型</div>
                <div class="order-info-value">{{ tableData.storeName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">套包信息</div>
                <div class="order-info-value" style="word-break: break-all;">{{ tableData.packageInfo || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">品牌</div>
                <div class="order-info-value">{{ tableData.deviceBrandName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">车型</div>
                <div class="order-info-value">{{ tableData.modelName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">客户名</div>
                <div class="order-info-value">{{ tableData.customerName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">客户电话</div>
                <div class="order-info-value">{{ tableData.phone || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">安装联系人</div>
                <div class="order-info-value">{{ tableData.installerInfo || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">安装联系人电话</div>
                <div class="order-info-value order-info-value--wrap">{{ tableData.installerPhone || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">交车日期</div>
                <div class="order-info-value">{{ tableData.deliveryDate || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">所属区域</div>
                <div class="order-info-value">{{ tableData.regionName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">所属公司</div>
                <div class="order-info-value">{{ tableData.companyName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">省</div>
                <div class="order-info-value">{{ tableData.provinceName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">市</div>
                <div class="order-info-value">{{ tableData.cityName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">区县</div>
                <div class="order-info-value">{{ tableData.areaName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">详细地址</div>
                <div class="order-info-value" style="word-break: break-all;">{{ tableData.detailAddress || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">充电桩编号</div>
                <div class="order-info-value">{{ tableData.deviceNum || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">车架号</div>
                <div class="order-info-value">{{ tableData.frameNo || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">订单金额</div>
                <div class="order-info-value">{{ tableData.price || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">负责师傅</div>
                <div class="order-info-value">{{ tableData.masterWorkerName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">完工时间</div>
                <div class="order-info-value">{{ dateFormat(tableData.installTime) || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">完工提交时间</div>
                <div class="order-info-value">{{ dateFormat(tableData.installFinishTime) || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">预约时间</div>
                <div class="order-info-value">{{ dateFormat(tableData.subscribeTime) || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">录单人</div>
                <div class="order-info-value">{{ tableData.recordUserName || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">录单时间</div>
                <div class="order-info-value">{{ dateFormat(tableData.recordTime) || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">是否带桩</div>
                <div class="order-info-value">{{ tableData.isDockingRequired ? '是' : '否' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">用线长度</div>
                <div class="order-info-value">{{ tableData.lineLength || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">增项费用</div>
                <div class="order-info-value">{{ tableData.addOutlay || '-' }}</div>
              </div>
              <div class="order-info-item">
                <div class="order-info-label">订单备注</div>
                <div class="order-info-value" style="word-break: break-all;">{{ tableData.orderRemark || '-' }}</div>
              </div>
              <div class="order-info-item" v-if="tableData.rejectRemark">
                <div class="order-info-label">驳回理由</div>
                <div class="order-info-value" style="word-break: break-all; color: #ff6b6b;">{{ tableData.rejectRemark }}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="新增"
      :visible.sync="dialogFollowAdd"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="followArr" label-width="160px" size="small" style="width: 600px">
        <el-form-item label="客户姓名" prop="customerName" v-show="false">
          <el-input v-model="followArr.customerName"></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="phone" v-show="false">
          <el-input v-model="followArr.phone" :min="0"></el-input>
        </el-form-item>
        <el-form-item label="跟进备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入内容"
            v-model="followArr.followRemark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="dialogFollowAdd = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addFollowSubMit('followArr')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { authorization } from "../../../authorization/authorization";
import { listDictByType } from "@/components/admin/common/util.js";
import orderUtils from "@/components/admin/order/orderUtils";
import {
  statusFormat,
  statusFormatByStatus,
  orderTypeFormat,
  repairTypeFormat,
  houseTypeFormat,
} from "../common/format";
import ImageCompressor from "compressorjs";
import { buildImageClipboardMetaPayload } from "@/utils/imageClipboard";
export default {
  data() {
    return {
      optionProps: {
        value: "value",
        label: "text",
        children: "children",
      },
      deviceListX: [],
      orderId: "",
      materialList: [],
      materialModelList: [],
      row: {},
      imgDownloadLoading: false,
      dialogUpdate: false,
      dialogFormExamine: false,
      dialogAddMaterial: false,
      dialogUpdateImage: false,
      dialogFollowAdd: false,
      dialogImagePreview: false,
      currentPreviewImage: "",
      previewImageList: [],
      previewImageMetaList: [], // 存储图片的元数据（类型、类型内索引等）
      currentPreviewIndex: 0,
      thumbnailActiveIndex: 0,
      previewImageCache: {},
      imageScale: 1,
      imageRotate: 0,
      imageTranslateX: 0,
      imageTranslateY: 0,
      isDragging: false,
      dragStart: { x: 0, y: 0 },
      deviceUpdateClick: false,
      activeName: this.$route.query.activeName,
      page: this.$route.query.page,
      tableData: [],
      modelTableData: [],
      materialOrderList: [],
      templateDetailList: [],
      otherImgList: [],
      reserve3List: [],
      surveyImageList: [],
      courierImageList: [],
      companyInfo: {},
      addMaterialParams: {
        modeAndTypeId: [],
        orderId: "",
        typeId: "",
        modelId: "",
        num: "",
        meterialPrice: "",
        actualAmount: 0,
      },
      followArr: {
        orderId: "",
        customerName: "",
        phone: "",
        followRemark: "",
      },
      updateParams: {
        deviceNum: "",
        lineLength: "",
        addOutlay: "",
      },
      dialogVisible: false, // 控制对话框的显示与隐藏
      completeInstallForm: {
        orderId: "",
        completeTimeX: "",
        detailAddressX: "",
      },
      rulesX: {
        completeTimeX: [{ required: true, message: "请选择完工时间", trigger: "change" }],
        detailAddressX: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
      },
      editTime: {
        subscribeTime: "",
        isDockingRequired: "",
        installTime: "",
        isResponsible: "",
      },
      deviceNumParams: {
        numNotNull: "true",
        status: 0,
        isContainsGroup: true,
        haveUser: "",
        categoryId: "",
        companyId: "",
      },
      isDetailEditMode: false,
      examine: {
        orderId: "",
        orderIds: [],
        rejectRemark: "",
        type: "",
      },
      imageUpdateParams: {
        templateDetailList: [],
      },
      imagePreviewUrl: "",
      imageSetting: {},
      deviceCategoryList: [],
      powerSourceCol: ["独立电表", "物业取电", "自家电表", "其他"],
      cableBrandCol: [],
      houseTypeList: [
        { id: 0, houseTypeName: "农村自建房" },
        { id: 1, houseTypeName: "城市小区" },
        { id: 2, houseTypeName: "城市自建房" },
        { id: 3, houseTypeName: "工厂" },
        { id: 4, houseTypeName: "其他" },
      ],
      choiceList1: [
        {
          value: 0,
          label: "未签",
        },
        {
          value: 1,
          label: "已签",
        },
      ],
      choiceListX: [
        {
          value: false,
          label: "否",
        },
        {
          value: true,
          label: "是",
        },
      ],
      choiceList2: [
        {
          value: 0,
          label: "未购买",
        },
        {
          value: 1,
          label: "已购买",
        },
      ],
      frontEndCableOptions: [
        { value: 1, label: "铜" },
        { value: 2, label: "铝" },
        { value: 9, label: "其他" },
      ],
      isEdit: [],
      sourceTypeListMap: {},
    };
  },
  beforeCreate() {
    listDictByType("问题来源").then((res) => {
      if (res.status === 200) {
        this.sourceTypeListMap = new Map(
          res.data.map((item) => [item.value, item.label])
        );
      }
    });
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.queryDeviceCategoryList();
    this.selMaterialType();
    this.queryCableBrandDrown();
    this.queryMaterialModelList();
    this.queryDetailList();
    this.queryFollow();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.tableData.doLayout();
    });
  },
  mounted() {
    // 添加键盘事件监听
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    // 移除键盘事件监听
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    valueByKey: orderUtils.valueByKey,
    houseTypeFormat,
    authorization,
    statusFormat,
    statusFormatByStatus,
    orderTypeFormat,
    repairTypeFormat,
    queryFollow() {
      this.axios({
        method: "get",
        //后端接口
        url: "/v1/web/order-info/get-order-all-follow/" + this.orderId,
      }).then((res) => {
        console.log(res.data.data);
        this.modelTableData = res.data.data;
      });
    },
    getCompany(companyId) {
      this.axios({
        method: "get",
        url: "/v1/web/company-manager/select-company",
        params: { companyIdEqual: companyId, page: 1, size: 10 },
      }).then((res) => {
        this.companyInfo = res.data.data.list[0];
        if (this.companyInfo != null && this.companyInfo.categoryIdList != null) {
          let categoryArr = this.companyInfo.categoryIdList;
          let deviceArr = this.deviceCategoryList.filter((x) => {
            return categoryArr.indexOf(x.id) >= 0;
          });
          this.deviceCategoryList = [...deviceArr];
        }
      });
    },
    queryCableBrandDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/cable-brand/select-cable-brand",
      }).then((res) => {
        this.cableBrandCol = res.data.data.list;
        this.cableBrandCol.push({ id: -1, brandName: "其他" });
      });
    },
    queryDeviceCategoryList() {
      this.axios({
        method: "get",
        url: "/v1/web/device-category/select-category",
      }).then((res) => {
        this.deviceCategoryList = res.data.data.list;
      });
    },
    deleteMaterial(row) {
      this.axios({
        method: "delete",
        url: "/v1/web/order-info/delete-material/" + row.id,
        params: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "删除成功", type: "success" });
          this.queryDetailList();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    //获取物料类型
    selMaterialType() {
      this.axios({
        method: "get",
        url: "/v1/h5/order-info/select-material-type-drown",
      }).then((res) => {
        this.materialList = res.data.data;
      });
    },
    queryMaterialModelList() {
      //获取物料类型列表
      let params = { size: -1 };
      this.axios({
        method: "get",
        url: "/v1/web/material-model/select-material-model",
        params: params,
      }).then((res) => {
        this.materialModelList = res.data.data.list;
      });
    },
    addMaterial() {
      this.addMaterialParams = {
        modeAndTypeId: [],
        orderId: "",
        typeId: "",
        modelId: "",
        num: 1,
        meterialPrice: "",
        actualAmount: 0,
      };
      this.dialogAddMaterial = true;
    },
    saveMaterial() {
      this.addMaterialParams.typeId = this.addMaterialParams.modeAndTypeId[0];
      this.addMaterialParams.modelId = this.addMaterialParams.modeAndTypeId[1];
      this.axios({
        method: "post",
        url: "/v1/web/order-info/add-material/" + this.tableData.id,
        data: this.addMaterialParams,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "添加成功", type: "success" });
          this.dialogAddMaterial = false;
          this.queryDetailList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    materialChanged(e) {
      if (
        e != null &&
        e.length > 1 &&
        this.materialModelList != null &&
        this.materialModelList.length > 0
      ) {
        let price = this.materialModelList.find((x) => x.id == e[1])?.price;
        this.addMaterialParams.meterialPrice = price;
        this.calcTotal(this.addMaterialParams);
      }
    },
    deviceUpdate() {
      this.deviceUpdateClick = true;
      this.getDeviceByCategoryX();
    },
    deviceUpdateCancle() {
      this.tableData = { ...this.row };
      this.deviceUpdateClick = false;
    },
    saveUpdate() {
      this.tableData.updateType = 0;
      this.axios({
        method: "post",
        url: "/v1/web/order-info/update-order-part/" + this.tableData.id,
        data: this.tableData,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "保存成功", type: "success" });
          this.deviceUpdateClick = false;
          this.queryDetailList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        if (index === 1 || index === 6) {
          sums[index] = "";
          return;
        }
        // if (index === 4) {
        //   sums[index] = sums[2] *  sums[3];
        //   return;
        // }
        const values = data.map((item) => Number(item[column.property]));
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      });
      return sums;
    },
    isDockingRequiredFormat(isDocking) {
      if (isDocking) {
        return "是";
      } else {
        return "否";
      }
    },
    getHouseTypeName(id) {
      const houseType = this.houseTypeList.find((item) => item.id === id);
      return houseType ? houseType.houseTypeName : "未知";
    },
    examineOrder(formName, type) {
      //驳回订单
      this.examine.type = type;
      this.axios({
        method: "post",
        url: "/v1/web/order-info/examine-order",
        data: this.examine,
      }).then((res) => {
        if (res.data.code === 200) {
          if (type == 4) {
            this.$message({ message: "驳回成功", type: "info" });
          } else if (type == 6) {
            this.$message({
              message: "审核通过",
              type: "success",
            });
          }
          this.tableData.status = type;
          this.dialogFormExamine = false;
          this.examine.rejectRemark = "";
          this.examine.type = "";
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    completeInstall() {},
    getWorkerId() {},
    getDeviceByCategoryX() {
      console.log(this.tableData);
      console.log(this.tableData.storeId);

      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: this.deviceNumParams,
      }).then((res) => {
        this.deviceListX = res.data.data.list;
        console.log(this.deviceListX);
      });
    },

    scrollToDiv() {
      // 获取目标 div 并滚动到该元素
      const targetDiv = this.$refs.targetDiv;
      targetDiv.scrollIntoView({
        behavior: "smooth", // 平滑滚动效果
        block: "start", // 滚动到元素的顶部
      });
    },
    openCompleteDialog() {
      this.completeInstallForm.completeTimeX = this.dateFormat(
        this.tableData.installTime
      );
      this.completeInstallForm.detailAddressX = this.tableData.detailAddress;
      if (this.templateDetailList.length == 0) {
        this.scrollToDiv();
        this.showInfoNotification();
        return;
      }
      // 新订单类型
      if (this.tableData.orderType === 1) {
        if (!this.tableData.frontEndCable) {
          this.$notify({
            title: "提示信息",
            message: "【新订单】前端线材必选,请选择后再尝试完成安装",
            type: "error",
          });
          return;
        }
      }

      this.axios({
        method: "get",
        url: "/v1/web/order-info/installTime-detail",
        params: {
          orderId: this.orderId,
        },
      }).then((res) => {
        console.log(res.data.data);
        this.completeInstallForm.completeTimeX = res.data.data.completeTimeX;
        this.completeInstallForm.detailAddressX = res.data.data.detailAddressX;
      });

      this.dialogVisible = true;
      this.completeInstallForm.orderId = this.orderId;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    showInfoNotification() {
      this.$notify({
        title: "提示信息",
        message: "请到图片信息中上传相关图片,再尝试完成安装",
        type: "error",
      });
    },
    submitForm() {
      console.log(this.completeInstallForm);

      this.$refs.form.validate((valid) => {
        if (valid) {
          // 如果表单验证通过，发送 POST 请求到后端
          this.axios({
            method: "post",
            url: "/v1/web/order-info/complete-order",
            data: this.completeInstallForm,
          })
            .then((response) => {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              response;
              this.dialogVisible = false;
              console.log(this.completeInstallForm);
              // 处理成功的响应
              this.queryDetailList();
            })
            .catch((error) => {
              error;
              // 处理请求错误
              this.$message({
                message: "提交失败，请重试",
                type: "error",
              });
            });
        } else {
          this.$message({
            message: "请检查表单输入",
            type: "warning",
          });
          return false;
        }
      });
    },
    examines() {
      this.examine = {
        orderId: this.row.id,
        orderIds: [this.row.id],
        rejectRemark: "",
        type: "",
      };
      this.dialogFormExamine = true;
    },
    totalPrice: function (row) {
      return row.num * row.meterialPrice;
    },
    getFollowRemarkList(followRemark) {
      if (followRemark === undefined || followRemark === null) {
        return [];
      }
      return followRemark.split(";");
    },
    goback() {
      this.$router.push({
        path:
          this.$route.query.isRepairOrder || this.$route.query.repairOrderTo
            ? "/home-admin/order/repair-order"
            : "/home-admin/order/order-manage",
        query: { activeName: this.activeName, page: this.page },
      });
    },
    downloadVideo() {
      this.imgDownloadLoading = true;
      this.axios({
        method: "post",
        url: "/v1/web/order-info/video-download",
        data: { orderId: this.row.id },
        responseType: "blob",
      })
        .then((res) => {
          let filename = res.headers["content-disposition"];
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/octet-stream" });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            decodeURI(filename.substring(filename.indexOf("=") + 1, filename.length))
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.imgDownloadLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.imgDownloadLoading = false;
        });
    },
    cancelEditDetail() {
      this.isDetailEditMode = false;
    },
    saveEditdDetail() {
      console.log(this.editTime);
      console.log(this.tableData);
      this.axios({
        method: "post",
        url: "/v1/web/order-info/update-order-detail",
        data: this.editTime,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "修改成功", type: "success" });
          this.isDetailEditMode = false;
          this.tableData.installTime = this.editTime.installTime;
          this.tableData.subscribeTime = this.editTime.subscribeTime;
          this.tableData.isDockingRequired = this.editTime.isDockingRequired;
          this.tableData.isResponsible = this.editTime.isResponsible;

          if (this.editTime.isResponsible === 1) {
            this.tableData.isResponsibleStr = "是";
          }
          if (this.editTime.isResponsible === 0) {
            this.tableData.isResponsibleStr = "否";
          }

          this.this.queryDetailList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    editDetail() {
      this.isDetailEditMode = true;
      this.editTime.orderId = this.orderId;
    },
    download() {
      //批量下载
      this.imgDownloadLoading = true;
      this.orderIdList = [];
      this.orderIdList.push(this.row.id);
      this.axios({
        method: "post",
        url: "/v1/web/order-info/image-download",
        data: { orderIds: this.orderIdList },
        responseType: "blob",
      })
        .then((res) => {
          let filename = res.headers["content-disposition"];
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/zip" }); //类型excel
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            decodeURI(
              filename.substring(filename.indexOf("=") + 1, filename.lastIndexOf("."))
            )
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.imgDownloadLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.imgDownloadLoading = false;
        });
    },
    queryDetailList() {
      //获取订单详情数据
      this.axios({
        method: "get",
        url: "/v1/web/order-info/select-order-detail",
        params: { id: this.orderId },
      }).then((res) => {
        this.row = res.data.data;
        this.tableData = { ...this.row };

        if (this.tableData.sourceOrderId) {
          this.tableData.sourceOrderIdStr = this.sourceTypeListMap.get(
            this.tableData.sourceOrderId + ""
          );
        }
        if (this.tableData.isResponsible === true) {
          this.tableData.isResponsibleStr = "是";
          this.tableData.isResponsible = 1;
        }
        if (this.tableData.isResponsible === false) {
          this.tableData.isResponsibleStr = "否";
          this.tableData.isResponsible = 0;
        }

        console.log(this.tableData.masterWorker);
        this.deviceNumParams.haveUser = this.tableData.masterWorker;
        this.deviceNumParams.categoryId = this.tableData.categoryId;
        this.deviceNumParams.companyId = this.tableData.companyId;

        this.editTime.subscribeTime = this.dateFormat(this.tableData.subscribeTime);
        this.editTime.installTime = this.dateFormat(this.tableData.installTime);
        this.editTime.isDockingRequired = this.tableData.isDockingRequired;
        this.editTime.detailAddress = this.tableData.detailAddress;
        this.editTime.isResponsible = this.tableData.isResponsible;
        let surveyImageArr = [];
        if (
          res.data.data.surveyImageUrl !== null &&
          res.data.data.surveyImageUrl !== ""
        ) {
          surveyImageArr = res.data.data.surveyImageUrl.split(",");
        }
        let reserve1Array = [];
        if (res.data.data.reserve1 !== null) {
          reserve1Array = res.data.data.reserve1.split(",");
        }

        let reserve3Arr = [];
        if (res.data.data.reserve3 !== null) {
          reserve3Arr = res.data.data.reserve3.split(",");
        }

        this.reserve3List = [];
        for (let i = 0; i < reserve3Arr.length; i++) {
          this.reserve3List.push(this.changeImageUrl(reserve3Arr[i]));
        }

        this.surveyImageList = [];
        for (let i = 0; i < surveyImageArr.length; i++) {
          this.surveyImageList.push(this.changeImageUrl(surveyImageArr[i]));
        }

        this.otherImgList = [];
        for (let i = 0; i < reserve1Array.length; i++) {
          this.otherImgList.push(this.changeImageUrl(reserve1Array[i]));
        }

        this.courierImageList = [];
        let orderCourier = this.row.orderCourier;
        if (
          orderCourier != null &&
          orderCourier.courierImageUrl != null &&
          orderCourier.courierImageUrl != ""
        ) {
          this.courierImageList.push(this.changeImageUrl(orderCourier.courierImageUrl));
        }

        this.materialOrderList = res.data.data.materialOrderList;

        if (this.row.companyId != null && this.row.companyId != "") {
          this.getCompany(this.row.companyId);
        }

        this.selectImageSetting();
        this.selectOrderImageSettingDetailList();
      });
    },
    selectOrderImageSettingDetailList() {
      this.templateDetailList = [];
      this.axios({
        method: "get",
        url: "/v1/web/device-image-setting/select-order-image-detail",
        params: {
          orderId: this.orderId,
        },
      }).then((res) => {
        let resultData = res.data.data;
        if (resultData != null && resultData.length > 0) {
          this.templateDetailList = resultData;
        }
      });
    },
    changeImageUrl(imageUrl) {
      //转换图片路径
      if (imageUrl === null || imageUrl === "") {
        return "#";
      }
      return "/api/v1/web/order-info/preview-image?path=" + imageUrl;
    },
    getFirstImageUrl(imageUrl) {
      //获取第一张图片的URL
      if (imageUrl === null || imageUrl === "") {
        return "#";
      }
      let urls = imageUrl.split(",");
      if (urls.length > 0 && urls[0].trim()) {
        return this.changeImageUrl(urls[0].trim());
      }
      return this.changeImageUrl(imageUrl);
    },
    getImageCount(imageUrl) {
      //获取图片数量
      if (imageUrl === null || imageUrl === "") {
        return 0;
      }
      let urls = imageUrl.split(",").filter(url => url && url.trim());
      return urls.length;
    },
    getImagePreviewList(imageUrl) {
      //获取预览图片列表（所有图片的URL数组）
      if (imageUrl === null || imageUrl === "") {
        return [];
      }
      let urls = imageUrl.split(",").filter(url => url && url.trim());
      return urls.map(url => this.changeImageUrl(url.trim()));
    },
    // 收集所有类型的图片，返回包含元数据的列表
    collectAllImages() {
      const allImages = [];
      const allMeta = [];
      
      // 1. 收集模板图片
      if (this.templateDetailList && this.templateDetailList.length > 0) {
        this.templateDetailList.forEach(img => {
          if (img.url && img.url !== "") {
            const urls = img.url.split(",").filter(url => url && url.trim());
            urls.forEach((url, index) => {
              allImages.push(this.changeImageUrl(url.trim()));
              allMeta.push({
                typeName: img.imageName,
                typeIndex: index + 1,
                originalType: 'template',
                originalIndex: index
              });
            });
          }
        });
      }
      
      // 2. 收集免责图
      if (this.reserve3List && this.reserve3List.length > 0) {
        this.reserve3List.forEach((url, index) => {
          allImages.push(url);
          allMeta.push({
            typeName: '免责图',
            typeIndex: index + 1,
            originalType: 'reserve3',
            originalIndex: index
          });
        });
      }
      
      // 3. 收集勘测确认图
      if (this.surveyImageList && this.surveyImageList.length > 0) {
        this.surveyImageList.forEach((url, index) => {
          allImages.push(url);
          allMeta.push({
            typeName: '勘测确认图',
            typeIndex: index + 1,
            originalType: 'survey',
            originalIndex: index
          });
        });
      }
      
      // 4. 收集其他多图
      if (this.otherImgList && this.otherImgList.length > 0) {
        this.otherImgList.forEach((url, index) => {
          allImages.push(url);
          allMeta.push({
            typeName: '其他多图',
            typeIndex: index + 1,
            originalType: 'other',
            originalIndex: index
          });
        });
      }
      
      // 5. 收集快递单据图
      if (this.courierImageList && this.courierImageList.length > 0) {
        this.courierImageList.forEach((url, index) => {
          allImages.push(url);
          allMeta.push({
            typeName: '快递单据图',
            typeIndex: index + 1,
            originalType: 'courier',
            originalIndex: index
          });
        });
      }
      
      this.annotateImageMetaTotals(allMeta);
      return { images: allImages, meta: allMeta };
    },
    annotateImageMetaTotals(meta) {
      const countByType = {};
      meta.forEach((item) => {
        countByType[item.typeName] = (countByType[item.typeName] || 0) + 1;
      });
      meta.forEach((item) => {
        item.typeTotal = countByType[item.typeName] || 1;
      });
      return meta;
    },
    formatPreviewTypeTitle(metaItem) {
      if (!metaItem) {
        return "";
      }
      const total = metaItem.typeTotal || 1;
      if (total <= 1) {
        return metaItem.typeName;
      }
      return `${metaItem.typeName} ${metaItem.typeIndex}/${total}`;
    },
    // 根据点击的图片找到在所有图片中的索引
    findImageIndexInAllImages(clickedImageUrl, clickedType, clickedTypeIndex) {
      const { images, meta } = this.collectAllImages();
      
      // 根据类型和类型内索引查找
      for (let i = 0; i < meta.length; i++) {
        if (meta[i].originalType === clickedType && 
            meta[i].typeIndex === clickedTypeIndex) {
          return i;
        }
      }
      
      // 如果找不到，尝试通过URL匹配
      for (let i = 0; i < images.length; i++) {
        if (images[i] === clickedImageUrl) {
          return i;
        }
      }
      
      return 0;
    },
    resetImageUrl(imageUrl) {
      //转换为相对路径
      if (imageUrl === null || imageUrl === "") {
        return "";
      }
      return imageUrl.replace("/api/v1/web/order-info/preview-image?path=", "");
    },
    dateFormat(time) {
      if (time !== null && time !== undefined) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    selectImageSetting() {
      let params = {
        orderType: this.tableData.orderType,
        repairType: this.tableData.orderType === 2 ? this.tableData.repairType : null,
        deviceCategoryId: this.tableData.storeId,
      };
      console.log(params.deviceCategoryId);
      this.axios({
        method: "get",
        url: "/v1/web/device-image-setting/select-image-setting",
        params: params,
      }).then((res) => {
        if (res.data.data.list.length > 0) {
          this.imageSetting = res.data.data.list[0];
        }
      });
    },
    saveImageUpdate() {
      if (
        this.imageUpdateParams.reserve1List != null &&
        this.imageUpdateParams.reserve1List.length > 0
      ) {
        let urlArr = [];
        for (let i = 0; i < this.imageUpdateParams.reserve1List.length; i++) {
          let image = this.imageUpdateParams.reserve1List[i];
          urlArr.push(this.resetImageUrl(image.url));
        }
        this.imageUpdateParams.reserve1 = urlArr.join(",");
      }

      if (
        this.imageUpdateParams.reserve3List != null &&
        this.imageUpdateParams.reserve3List.length > 0
      ) {
        let urlArr = [];
        for (let i = 0; i < this.imageUpdateParams.reserve3List.length; i++) {
          let image = this.imageUpdateParams.reserve3List[i];
          urlArr.push(this.resetImageUrl(image.url));
        }
        this.imageUpdateParams.reserve3 = urlArr.join(",");
      }

      if (
        this.imageUpdateParams.surveyImageList != null &&
        this.imageUpdateParams.surveyImageList.length > 0
      ) {
        let urlArr = [];
        for (let i = 0; i < this.imageUpdateParams.surveyImageList.length; i++) {
          let image = this.imageUpdateParams.surveyImageList[i];
          urlArr.push(this.resetImageUrl(image.url));
        }
        this.imageUpdateParams.surveyImageUrl = urlArr.join(",");
      }

      // if (this.imageUpdateParams.templateDetailList != null && this.imageUpdateParams.templateDetailList.length > 0) {
      //   for (let i = 0; i < this.imageUpdateParams.templateDetailList.length; i++) {
      //     let image = this.imageUpdateParams.templateDetailList[i];
      //     if (image.isRequired === 1 && (image.url == null || image.url == "" || image.miniUrl == null || image.miniUrl == "")) {
      //       this.$message.error(image.imageName + '不能为空');
      //       return;
      //     }
      //   }
      // }

      // if (this.imageUpdateParams.signExemption === 1 && (this.imageUpdateParams.reserve3 == null || this.imageUpdateParams.reserve3 == "")) {
      //   this.$message.error('订单已经签免责，免责图不能为空');
      //   return;
      // }

      // if (this.imageUpdateParams.surveyImageUrl == null || this.imageUpdateParams.surveyImageUrl == "") {
      //   this.$message.error('勘测确认图不能为空');
      //   return;
      // }

      this.imageUpdateParams.updateType = 1;
      this.axios({
        method: "post",
        url: "/v1/web/order-info/update-order-part/" + this.imageUpdateParams.id,
        data: this.imageUpdateParams,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "保存成功", type: "success" });
          this.dialogUpdateImage = false;
          this.queryDetailList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleImageReset() {
      this.$confirm("重置图片模板数据会清空当前订单的所有模板图片，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.axios({
          method: "delete",
          url: "/v1/web/order-info/resetImage/" + this.tableData.id,
          params: {
            id: this.tableData.id,
          },
        }).then((res) => {
          if (res.data.code === 200) {
            this.$message({ message: "重置图片模板成功", type: "success" });
            this.queryDetailList();
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        });
      });
    },
    handleImageUpdate() {
      this.imageUpdateParams = JSON.parse(JSON.stringify(this.tableData));
      if (this.templateDetailList != null && this.templateDetailList.length > 0) {
        this.imageUpdateParams.templateDetailList = JSON.parse(
          JSON.stringify(this.templateDetailList)
        );
      } else {
        this.imageUpdateParams.templateDetailList = JSON.parse(
          JSON.stringify(this.imageSetting.templateDetailList)
        );
      }

      for (let i = 0; i < this.imageUpdateParams.templateDetailList.length; i++) {
        let img = this.imageUpdateParams.templateDetailList[i];
        if (
          img.miniUrl != null &&
          img.miniUrl != "" &&
          img.url != null &&
          img.url != ""
        ) {
          img.imgList = [];
          // 支持多张图片，URL可能是逗号分隔的
          let urls = img.url.split(",");
          let miniUrls = img.miniUrl.split(",");
          for (let j = 0; j < urls.length && j < miniUrls.length; j++) {
            if (urls[j] && urls[j].trim() && miniUrls[j] && miniUrls[j].trim()) {
              let imgObj = { 
                name: img.imageName + (urls.length > 1 ? (j + 1) : ""), 
                url: this.changeImageUrl(miniUrls[j].trim()) 
              };
              img.imgList.push(imgObj);
            }
          }
        }
      }

      this.imageUpdateParams.reserve3List = [];
      if (this.reserve3List != null && this.reserve3List.length > 0) {
        for (let i = 0; i < this.reserve3List.length; i++) {
          let imgObj = { name: "免责图" + i, url: this.reserve3List[i] };
          this.imageUpdateParams.reserve3List.push(imgObj);
        }
      }

      this.imageUpdateParams.surveyImageList = [];
      if (this.surveyImageList != null && this.surveyImageList.length > 0) {
        for (let i = 0; i < this.surveyImageList.length; i++) {
          let imgObj = { name: "勘测确认单" + i, url: this.surveyImageList[i] };
          this.imageUpdateParams.surveyImageList.push(imgObj);
        }
      }

      this.imageUpdateParams.reserve1List = [];
      if (this.otherImgList != null && this.otherImgList.length > 0) {
        for (let i = 0; i < this.otherImgList.length; i++) {
          let imgObj = { name: "其他图片" + i, url: this.otherImgList[i] };
          this.imageUpdateParams.reserve1List.push(imgObj);
        }
      }

      this.imageUpdateParams.videoList = [];
      if (
        this.imageUpdateParams.videoUrl != null &&
        this.imageUpdateParams.videoUrl != ""
      ) {
        let imgObj = {
          name: "视频",
          url: this.changeImageUrl(this.imageUpdateParams.videoUrl),
        };
        this.imageUpdateParams.videoList.push(imgObj);
      }

      this.dialogUpdateImage = true;
    },
    handlePictureCardPreview(file) {
      this.imagePreviewUrl = file.url;
      this.dialogImagePreview = true;
    },
    openImagePreview(img) {
      //打开图片预览 - 预览所有类型图片
      const { images, meta } = this.collectAllImages();
      
      if (images.length === 0) {
        return;
      }
      
      // 找到点击的图片在所有图片中的索引
      // 模板图片：根据imageName和第一张图片的URL来定位
      let targetIndex = 0;
      const templateImageUrls = this.getImagePreviewList(img.url);
      if (templateImageUrls.length > 0) {
        // 找到该模板图片的第一张在所有图片中的位置
        for (let i = 0; i < meta.length; i++) {
          if (meta[i].typeName === img.imageName && meta[i].typeIndex === 1) {
            targetIndex = i;
            break;
          }
        }
      }
      
      this.previewImageList = images;
      this.previewImageMetaList = meta;
      this.currentPreviewIndex = targetIndex;
      this.thumbnailActiveIndex = targetIndex;
      this.currentPreviewImage = images[targetIndex];
      this.resetImageZoom();
      this.dialogImagePreview = true;
      this.preloadAdjacentImages(targetIndex);
    },
    openImagePreviewFromList(imageList, index) {
      //打开图片预览（从数组列表）- 预览所有类型图片
      if (!imageList || imageList.length === 0) {
        return;
      }
      
      const clickedIndex = index !== undefined && index !== null ? index : 0;
      const clickedImageUrl = imageList[clickedIndex];
      
      // 确定图片类型
      let imageType = 'other';
      let typeName = '其他多图';
      if (imageList === this.reserve3List) {
        imageType = 'reserve3';
        typeName = '免责图';
      } else if (imageList === this.surveyImageList) {
        imageType = 'survey';
        typeName = '勘测确认图';
      } else if (imageList === this.otherImgList) {
        imageType = 'other';
        typeName = '其他多图';
      } else if (imageList === this.courierImageList) {
        imageType = 'courier';
        typeName = '快递单据图';
      }
      
      // 收集所有图片
      const { images, meta } = this.collectAllImages();
      
      if (images.length === 0) {
        return;
      }
      
      // 找到点击的图片在所有图片中的索引
      let targetIndex = 0;
      for (let i = 0; i < meta.length; i++) {
        if (meta[i].originalType === imageType && 
            meta[i].typeIndex === clickedIndex + 1) {
          targetIndex = i;
          break;
        }
      }
      
      // 如果找不到，尝试通过URL匹配
      if (targetIndex === 0 && clickedImageUrl) {
        for (let i = 0; i < images.length; i++) {
          if (images[i] === clickedImageUrl) {
            targetIndex = i;
            break;
          }
        }
      }
      
      this.previewImageList = images;
      this.previewImageMetaList = meta;
      this.currentPreviewIndex = targetIndex;
      this.thumbnailActiveIndex = targetIndex;
      this.currentPreviewImage = images[targetIndex];
      this.resetImageZoom();
      this.dialogImagePreview = true;
      this.preloadAdjacentImages(targetIndex);
    },
    isPreviewImageCached(url) {
      const cached = this.previewImageCache[url];
      return (
        cached &&
        cached !== "loading" &&
        cached.complete &&
        cached.naturalWidth > 0
      );
    },
    preloadPreviewImage(url) {
      if (!url || url === "#" || this.isPreviewImageCached(url)) {
        return;
      }
      if (this.previewImageCache[url] === "loading") {
        return;
      }
      this.previewImageCache[url] = "loading";
      const img = new Image();
      img.onload = () => {
        this.previewImageCache[url] = img;
      };
      img.onerror = () => {
        this.$delete(this.previewImageCache, url);
      };
      img.src = url;
    },
    preloadAdjacentImages(index) {
      const list = this.previewImageList;
      if (!list || list.length <= 1) {
        return;
      }
      this.preloadPreviewImage(list[index]);
      const len = list.length;
      if (len <= 12) {
        list.forEach((url) => this.preloadPreviewImage(url));
        return;
      }
      [-2, -1, 1, 2].forEach((offset) => {
        const i = (index + offset + len) % len;
        this.preloadPreviewImage(list[i]);
      });
      this.scheduleRemainingPreviewPreload();
    },
    scheduleRemainingPreviewPreload() {
      if (this._previewPreloadRunning || !this.dialogImagePreview) {
        return;
      }
      const pendingUrls = this.previewImageList.filter(
        (url) => !this.isPreviewImageCached(url)
      );
      if (pendingUrls.length === 0) {
        return;
      }
      this._previewPreloadRunning = true;
      let ptr = 0;
      const step = () => {
        if (!this.dialogImagePreview || ptr >= pendingUrls.length) {
          this._previewPreloadRunning = false;
          return;
        }
        const batch = 4;
        for (let i = 0; i < batch && ptr < pendingUrls.length; i++) {
          this.preloadPreviewImage(pendingUrls[ptr]);
          ptr += 1;
        }
        window.setTimeout(step, 60);
      };
      step();
    },
    onImagePreviewOpened() {
      this.resetImageZoom();
      this.syncThumbnailActive(false);
      this.preloadAdjacentImages(this.currentPreviewIndex);
    },
    clearThumbnailSwitchTimer() {
      if (this._thumbnailSwitchTimer) {
        clearTimeout(this._thumbnailSwitchTimer);
        this._thumbnailSwitchTimer = null;
      }
    },
    syncThumbnailActive(delayUpdate) {
      const index = this.currentPreviewIndex;
      this.clearThumbnailSwitchTimer();
      if (delayUpdate) {
        this._thumbnailSwitchTimer = window.setTimeout(() => {
          this.thumbnailActiveIndex = index;
          this.scrollActiveThumbnailIntoView(true);
          this._thumbnailSwitchTimer = null;
        }, 500);
        return;
      }
      this.thumbnailActiveIndex = index;
      this.scrollActiveThumbnailIntoView(true);
    },
    clearThumbnailScrollAnimation() {
      if (this._thumbnailScrollAnimFrame) {
        cancelAnimationFrame(this._thumbnailScrollAnimFrame);
        this._thumbnailScrollAnimFrame = null;
      }
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    },
    isThumbnailFullyVisible(container, item) {
      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;
      const viewTop = container.scrollTop;
      const viewBottom = viewTop + container.clientHeight;
      return itemTop >= viewTop && itemBottom <= viewBottom;
    },
    getThumbnailScrollTarget(container, item) {
      const viewTop = container.scrollTop;
      const pageSize = container.clientHeight;
      const maxScroll = Math.max(0, container.scrollHeight - container.clientHeight);

      if (this.isThumbnailFullyVisible(container, item)) {
        return viewTop;
      }

      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;
      const viewBottom = viewTop + pageSize;

      // 当前项在可视区上方（含仅露出底部），向上翻一页
      if (itemBottom <= viewTop || itemTop < viewTop) {
        return Math.max(0, viewTop - pageSize);
      }

      // 当前项在可视区下方（含仅露出顶部），向下翻一页
      if (itemTop >= viewBottom || itemBottom > viewBottom) {
        return Math.min(viewTop + pageSize, maxScroll);
      }

      return viewTop;
    },
    animateThumbnailScroll(container, targetScrollTop, duration = 300, easing) {
      this.clearThumbnailScrollAnimation();
      const startScrollTop = container.scrollTop;
      const distance = targetScrollTop - startScrollTop;
      if (Math.abs(distance) < 1) {
        return;
      }
      const easeFn = easing || this.easeInOutCubic;
      const startTime = performance.now();
      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        container.scrollTop = startScrollTop + distance * easeFn(progress);
        if (progress < 1) {
          this._thumbnailScrollAnimFrame = requestAnimationFrame(step);
        } else {
          this._thumbnailScrollAnimFrame = null;
        }
      };
      this._thumbnailScrollAnimFrame = requestAnimationFrame(step);
    },
    scrollActiveThumbnailIntoView(animate) {
      this.$nextTick(() => {
        const container = this.$refs.imagePreviewThumbnails;
        if (!container || this.previewImageList.length <= 1) {
          return;
        }
        const items = container.querySelectorAll(".image-preview-thumbnail-item");
        const activeItem = items[this.thumbnailActiveIndex];
        if (!activeItem) {
          return;
        }
        const targetScrollTop = this.getThumbnailScrollTarget(container, activeItem);
        const needsScroll = Math.abs(targetScrollTop - container.scrollTop) >= 1;
        if (!needsScroll) {
          return;
        }
        if (!animate) {
          this.clearThumbnailScrollAnimation();
          container.scrollTop = targetScrollTop;
          return;
        }
        const duration = 1500;
        const easing = this.easeInOutCubic;
        this.animateThumbnailScroll(container, targetScrollTop, duration, easing);
      });
    },
    setPreviewIndex(index, delayThumbnail) {
      if (!this.previewImageList || this.previewImageList.length === 0) {
        return;
      }
      const total = this.previewImageList.length;
      const normalizedIndex = ((index % total) + total) % total;
      this.currentPreviewIndex = normalizedIndex;
      this.currentPreviewImage = this.previewImageList[normalizedIndex];
      this.resetImageZoom();
      this.preloadAdjacentImages(normalizedIndex);
      this.syncThumbnailActive(!!delayThumbnail);
    },
    prevImage() {
      if (!this.previewImageList || this.previewImageList.length === 0) {
        return;
      }
      if (this.currentPreviewIndex <= 0) {
        this.showPreviewBoundaryMessage("已经是第一张");
        return;
      }
      this.setPreviewIndex(this.currentPreviewIndex - 1, true);
    },
    nextImage() {
      if (!this.previewImageList || this.previewImageList.length === 0) {
        return;
      }
      if (this.currentPreviewIndex >= this.previewImageList.length - 1) {
        this.showPreviewBoundaryMessage("已经是最后一张");
        return;
      }
      this.setPreviewIndex(this.currentPreviewIndex + 1, true);
    },
    switchImage(index) {
      this.setPreviewIndex(index, false);
    },
    showPreviewImageMessage(message, type = "info") {
      this.$message({
        message,
        type,
        duration: 2000,
        customClass: "image-preview-boundary-message",
      });
    },
    showPreviewDirectoryPickerTip(message) {
      this.$message({
        message,
        type: "info",
        duration: 3500,
        customClass: "image-preview-boundary-message",
      });
    },
    delayBeforeDirectoryPicker(delayMs = 600) {
      return new Promise((resolve) => {
        setTimeout(resolve, delayMs);
      });
    },
    showPreviewBoundaryMessage(message) {
      this.showPreviewImageMessage(message);
    },
    resetImageZoom() {
      //重置图片缩放、旋转和位置
      this.imageScale = 1;
      this.imageRotate = 0;
      this.imageTranslateX = 0;
      this.imageTranslateY = 0;
      this.isDragging = false;
    },
    rotateLeft() {
      this.imageRotate -= 90;
    },
    rotateRight() {
      this.imageRotate += 90;
    },
    getCurrentPreviewImageTitle() {
      const meta = this.previewImageMetaList[this.currentPreviewIndex];
      if (meta) {
        return this.formatPreviewTypeTitle(meta);
      }
      if (this.previewImageList.length > 0) {
        return `图片 ${this.currentPreviewIndex + 1}`;
      }
      return "图片";
    },
    sanitizePreviewImageFileName(title) {
      return this.sanitizeDirectorySegment(title) || "图片";
    },
    getOrderPreviewDirectoryName() {
      const data =
        this.tableData && !Array.isArray(this.tableData) ? this.tableData : this.row || {};
      const candidates = [data.reserve2, data.pileModel, data.orderNum];
      for (let i = 0; i < candidates.length; i += 1) {
        const value = candidates[i];
        if (value == null || String(value).trim() === "") {
          continue;
        }
        const sanitized = this.sanitizeDirectorySegment(value);
        if (sanitized) {
          return sanitized;
        }
      }
      return "未命名订单";
    },
    sanitizeDirectorySegment(name) {
      return String(name)
        .replace(/[\\/:*?"<>|]/g, "-")
        .replace(/\s+/g, " ")
        .replace(/\.+$/g, "")
        .trim();
    },
    getImageExtensionFromMime(mimeType) {
      const map = {
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/gif": "gif",
        "image/webp": "webp",
        "image/bmp": "bmp",
      };
      return map[mimeType] || "png";
    },
    buildPreviewImageFileName(blob) {
      const title = this.sanitizePreviewImageFileName(this.getCurrentPreviewImageTitle());
      const ext = this.getImageExtensionFromMime(blob.type);
      return `${title}.${ext}`;
    },
    normalizeImageBlob(blob) {
      const type = blob.type && blob.type.startsWith("image/") ? blob.type : "image/png";
      if (blob.type === type) {
        return blob;
      }
      return new Blob([blob], { type });
    },
    normalizePreviewImageRequestUrl(imageUrl) {
      if (!imageUrl) {
        return "";
      }
      if (imageUrl.startsWith("/api")) {
        return imageUrl.slice(4);
      }
      return imageUrl;
    },
    async fetchPreviewImageBlob(imageUrl) {
      const requestUrl = this.normalizePreviewImageRequestUrl(imageUrl);
      if (!requestUrl) {
        throw new Error("empty image url");
      }
      const res = await this.axios({
        method: "get",
        url: requestUrl,
        responseType: "blob",
      });
      if (!(res.data instanceof Blob) || res.data.size === 0) {
        throw new Error("invalid image blob");
      }
      const contentType =
        (res.headers &&
          (res.headers["content-type"] || res.headers["Content-Type"])) ||
        res.data.type ||
        "";
      if (contentType && !contentType.startsWith("image/")) {
        throw new Error("invalid image content");
      }
      if (!res.data.type && contentType.startsWith("image/")) {
        return new Blob([res.data], { type: contentType.split(";")[0] });
      }
      return res.data;
    },
    async getPreviewImageBlobFromCanvas() {
      const img = this.$refs.previewImage;
      if (!img || !img.complete || !img.naturalWidth) {
        throw new Error("image not ready");
      }
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        throw new Error("canvas unavailable");
      }
      ctx.drawImage(img, 0, 0);
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("canvas toBlob failed"));
          }
        }, "image/png");
      });
    },
    async loadCurrentPreviewImageBlob() {
      const imageUrl = this.currentPreviewImage || this.imagePreviewUrl;
      if (!imageUrl) {
        throw new Error("empty image url");
      }
      try {
        return await this.getPreviewImageBlobFromCanvas();
      } catch (canvasError) {
        return this.fetchPreviewImageBlob(imageUrl);
      }
    },
    async needsDesktopRootDirectoryPicker() {
      if (typeof window.showDirectoryPicker !== "function") {
        return false;
      }
      const dirHandle = await this.getDesktopRootDirectoryHandle();
      if (!dirHandle) {
        return true;
      }
      return !(await this.verifyPreviewImageDirectoryPermission(dirHandle));
    },
    async getValidDesktopRootDirectory() {
      if (typeof window.showDirectoryPicker !== "function") {
        return null;
      }
      const dirHandle = await this.getDesktopRootDirectoryHandle();
      if (!dirHandle) {
        return null;
      }
      if (await this.verifyPreviewImageDirectoryPermission(dirHandle)) {
        return dirHandle;
      }
      return null;
    },
    openPreviewImageSettingsDb() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("electric-dispatch-preview-image", 1);
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains("settings")) {
            db.createObjectStore("settings");
          }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
    },
    getDesktopRootDirectoryHandle() {
      if (!window.indexedDB || typeof window.showDirectoryPicker !== "function") {
        return Promise.resolve(null);
      }
      return this.openPreviewImageSettingsDb().then(
        (db) =>
          new Promise((resolve, reject) => {
            const tx = db.transaction("settings", "readonly");
            const req = tx.objectStore("settings").get("desktopRootDirectoryHandle");
            req.onsuccess = () => resolve(req.result || null);
            req.onerror = () => reject(req.error);
          })
      );
    },
    setDesktopRootDirectoryHandle(handle) {
      return this.openPreviewImageSettingsDb().then(
        (db) =>
          new Promise((resolve, reject) => {
            const tx = db.transaction("settings", "readwrite");
            const req = tx.objectStore("settings").put(handle, "desktopRootDirectoryHandle");
            req.onsuccess = () => resolve();
            req.onerror = () => reject(req.error);
          })
      );
    },
    clearDesktopRootDirectoryHandle() {
      if (!window.indexedDB) {
        return Promise.resolve();
      }
      return this.openPreviewImageSettingsDb().then(
        (db) =>
          new Promise((resolve, reject) => {
            const tx = db.transaction("settings", "readwrite");
            const req = tx.objectStore("settings").delete("desktopRootDirectoryHandle");
            req.onsuccess = () => resolve();
            req.onerror = () => reject(req.error);
          })
      );
    },
    isDirectoryAccessError(error) {
      if (!error) {
        return false;
      }
      const errorName = error.name || "";
      return (
        errorName === "NotFoundError" ||
        errorName === "InvalidStateError" ||
        errorName === "SecurityError"
      );
    },
    getPreviewImageSaveDirectoryHandle() {
      return this.getDesktopRootDirectoryHandle();
    },
    setPreviewImageSaveDirectoryHandle(handle) {
      return this.setDesktopRootDirectoryHandle(handle);
    },
    async verifyPreviewImageDirectoryPermission(dirHandle) {
      if (!dirHandle) {
        return false;
      }
      const opts = { mode: "readwrite" };
      if ((await dirHandle.queryPermission(opts)) === "granted") {
        return true;
      }
      return (await dirHandle.requestPermission(opts)) === "granted";
    },
    async pickDesktopRootDirectory(tipMessage) {
      this.showPreviewDirectoryPickerTip(
        tipMessage || "请在桌面新建一个文件夹用于保存图片，然后选中该文件夹"
      );
      await this.delayBeforeDirectoryPicker();
      const dirHandle = await window.showDirectoryPicker({
        mode: "readwrite",
        startIn: "desktop",
      });
      await this.setDesktopRootDirectoryHandle(dirHandle);
      return dirHandle;
    },
    async getOrderPreviewSaveDirectoryFromHandle(rootHandle) {
      const orderNum = this.getOrderPreviewDirectoryName();
      const orderDirHandle = await rootHandle.getDirectoryHandle(orderNum, { create: true });
      return {
        rootHandle,
        orderDirHandle,
        saveFolderName: rootHandle.name || "保存文件夹",
      };
    },
    async savePreviewImageToDesktopOrderDir(blob, fileName, orderNum) {
      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          let rootHandle = await this.getValidDesktopRootDirectory();
          if (!rootHandle) {
            await this.pickDesktopRootDirectory(
              attempt > 0 ? "原保存文件夹已失效，请重新新建或选择保存文件夹" : undefined
            );
            rootHandle = await this.getValidDesktopRootDirectory();
          }
          if (!rootHandle) {
            throw new Error("directory unavailable");
          }
          const { orderDirHandle, saveFolderName } =
            await this.getOrderPreviewSaveDirectoryFromHandle(rootHandle);
          await this.saveBlobToPreviewDirectory(orderDirHandle, fileName, blob);
          this.showPreviewImageMessage(
            `已保存到 ${saveFolderName}/${orderNum}/${fileName}`
          );
          return;
        } catch (error) {
          if (error && error.name === "AbortError") {
            throw error;
          }
          if (attempt === 0 && this.isDirectoryAccessError(error)) {
            await this.clearDesktopRootDirectoryHandle();
            continue;
          }
          throw error;
        }
      }
    },
    async saveBlobToPreviewDirectory(dirHandle, fileName, blob) {
      const fileHandle = await dirHandle.getFileHandle(fileName, { create: true });
      const writable = await fileHandle.createWritable();
      await writable.write(blob);
      await writable.close();
      return fileHandle;
    },
    downloadPreviewImageBlob(blob, fileName) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    async writePreviewImageToClipboard(file, displayTitle) {
      if (!navigator.clipboard || typeof ClipboardItem === "undefined") {
        throw new Error("clipboard unsupported");
      }
      const type = file.type && file.type.startsWith("image/") ? file.type : "image/png";
      const metaPayload = buildImageClipboardMetaPayload(file.name, displayTitle);
      const clipboardPayload = {
        [type]: Promise.resolve(file),
        [metaPayload.type]: Promise.resolve(metaPayload.blob),
        "text/plain": Promise.resolve(new Blob([file.name], { type: "text/plain" })),
      };
      try {
        await navigator.clipboard.write([new ClipboardItem(clipboardPayload)]);
      } catch (writeError) {
        delete clipboardPayload[metaPayload.type];
        await navigator.clipboard.write([new ClipboardItem(clipboardPayload)]);
      }
    },
    createPreviewImageFile(blob, fileName) {
      const normalizedBlob = this.normalizeImageBlob(blob);
      const type =
        normalizedBlob.type && normalizedBlob.type.startsWith("image/")
          ? normalizedBlob.type
          : "image/png";
      return new File([normalizedBlob], fileName, { type, lastModified: Date.now() });
    },
    async copyCurrentPreviewImage() {
      try {
        const blob = await this.loadCurrentPreviewImageBlob();
        const normalizedBlob = this.normalizeImageBlob(blob);
        const fileName = this.buildPreviewImageFileName(normalizedBlob);
        const displayTitle = this.getCurrentPreviewImageTitle();
        const clipboardFile = this.createPreviewImageFile(normalizedBlob, fileName);
        await this.writePreviewImageToClipboard(clipboardFile, displayTitle);
        this.showPreviewImageMessage(`已复制「${displayTitle}」`);
      } catch (error) {
        if (error && error.message === "empty image url") {
          this.showPreviewImageMessage("暂无可复制的图片", "warning");
          return;
        }
        console.error(error);
        this.showPreviewImageMessage("复制失败，请检查剪贴板权限", "error");
      }
    },
    async saveCurrentPreviewImage() {
      try {
        const orderNum = this.getOrderPreviewDirectoryName();
        const canUseDirectoryPicker = typeof window.showDirectoryPicker === "function";
        const needPicker = canUseDirectoryPicker && (await this.needsDesktopRootDirectoryPicker());
        const blobPromise = this.loadCurrentPreviewImageBlob();

        if (needPicker) {
          await this.pickDesktopRootDirectory();
        }

        const normalizedBlob = this.normalizeImageBlob(await blobPromise);
        const fileName = this.buildPreviewImageFileName(normalizedBlob);

        if (canUseDirectoryPicker) {
          await this.savePreviewImageToDesktopOrderDir(normalizedBlob, fileName, orderNum);
          return;
        }

        this.downloadPreviewImageBlob(normalizedBlob, fileName);
        this.showPreviewImageMessage(`已下载 ${fileName}`);
      } catch (error) {
        if (error && error.message === "empty image url") {
          this.showPreviewImageMessage("暂无可保存的图片", "warning");
          return;
        }
        if (error && error.message === "invalid image content") {
          this.showPreviewImageMessage("图片数据无效，保存失败", "error");
          return;
        }
        if (error && (error.message === "cancel" || error.name === "AbortError")) {
          return;
        }
        console.error(error);
        this.showPreviewImageMessage("保存失败，请稍后重试", "error");
      }
    },
    handlePreviewClose() {
      //关闭预览时重置
      this.currentPreviewImage = '';
      this.previewImageList = [];
      this.previewImageMetaList = [];
      this.currentPreviewIndex = 0;
      this.thumbnailActiveIndex = 0;
      this.clearThumbnailSwitchTimer();
      this.clearThumbnailScrollAnimation();
      this.previewImageCache = {};
      this._previewPreloadRunning = false;
    },
    handleKeyDown(e) {
      // 只在预览对话框打开时处理键盘事件
      if (!this.dialogImagePreview) {
        return;
      }
      
      // ESC键关闭预览
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.dialogImagePreview = false;
        this.handlePreviewClose();
        return;
      }
      
      // 左箭头键 - 上一张
      if (e.key === 'ArrowLeft' || e.keyCode === 37) {
        e.preventDefault();
        this.prevImage();
        return;
      }
      
      // 右箭头键 - 下一张
      if (e.key === 'ArrowRight' || e.keyCode === 39) {
        e.preventDefault();
        this.nextImage();
        return;
      }
    },
    handleWheel(e) {
      //鼠标滚轮缩放
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      const newScale = Math.max(0.5, Math.min(5, this.imageScale + delta));
      this.imageScale = newScale;
      if (this.imageScale === 1) {
        this.imageTranslateX = 0;
        this.imageTranslateY = 0;
      }
    },
    handleDoubleClick(e) {
      // 仅双击图片本身时缩放，避免双击切换按钮等控件误触发
      if (!e.target || e.target.tagName !== "IMG") {
        return;
      }
      if (this.imageScale > 1) {
        this.resetImageZoom();
      } else {
        this.imageScale = 2;
      }
    },
    handleMouseDown(e) {
      //开始拖拽
      if (this.imageScale > 1 && e.target.tagName === 'IMG') {
        this.isDragging = true;
        const rect = this.$refs.imagePreviewContainer.getBoundingClientRect();
        this.dragStart.x = e.clientX - this.imageTranslateX;
        this.dragStart.y = e.clientY - this.imageTranslateY;
        e.preventDefault();
      }
    },
    handleMouseMove(e) {
      //拖拽移动
      if (this.isDragging && this.imageScale > 1) {
        this.imageTranslateX = e.clientX - this.dragStart.x;
        this.imageTranslateY = e.clientY - this.dragStart.y;
      }
    },
    handleMouseUp() {
      //结束拖拽
      this.isDragging = false;
    },
    zoomIn() {
      //放大
      this.imageScale = Math.min(5, this.imageScale + 0.5);
    },
    zoomOut() {
      //缩小
      this.imageScale = Math.max(0.5, this.imageScale - 0.5);
      if (this.imageScale === 1) {
        this.imageTranslateX = 0;
        this.imageTranslateY = 0;
      }
    },
    uploadVideo(file, fileList, type) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.uploadImage(file, type, false);
    },
    upload(file, fileList, type) {
      if (type === -1 || type === -2 || type === -3) {
        if (fileList.length >= 40) {
          this.$message.error("最多只能上传40张照片");
          return;
        }
      } else if (type > 0) {
        // 模板图片，检查maxCount限制
        if (
          this.imageUpdateParams.templateDetailList != null &&
          this.imageUpdateParams.templateDetailList.length > 0
        ) {
          let imgObj = this.imageUpdateParams.templateDetailList.find(
            (x) => x.id === type
          );
          if (imgObj) {
            let maxCount = imgObj.maxCount || 10;
            if (fileList.length > maxCount) {
              this.$message.error(imgObj.imageName + "最多只能上传" + maxCount + "张照片");
              fileList.splice(fileList.length - 1, 1);
              return;
            }
          }
        }
      } else if (type === -99) {
        // 视频只能上传一个
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }
        this.imageUpdateParams.videoList?.splice(0, 1);
      }

      this.clickUpload(type, file);
    },
    async clickUpload(type, file) {
      let miniFile = { ...file };
      let miniFileRaw, fileRaw;
      let miniSize = 100 * 1024;
      if (file.size > miniSize) {
        miniFileRaw = await this.compressFile(file.raw, 0.1);
        miniFile.raw = miniFileRaw;
      }

      let maxSize = 200 * 1024; //自己定义的文件大小，超过多少M就开始压缩(现在是200k)
      if (file.size > maxSize) {
        fileRaw = await this.compressFile(file.raw, 0.2);
        file.raw = fileRaw;
      }

      if (type > 0) {
        this.uploadImage(miniFile, type, true);
      }

      this.uploadImage(file, type, false);
    },
    uploadImage(file, type, isMini) {
      let obj = {};
      obj.name = file.name;
      let param = new FormData(); //创建form对象
      param.append("files", file.raw);
      param.append("orderNum", this.imageUpdateParams.orderNum);
      this.axios({
        method: "post",
        url: "/v1/h5/order-info/image-upload",
        data: param,
      })
        .then((res) => {
          let imgUrl = res.data.data.imageUrl;
          obj.url = this.changeImageUrl(res.data.data.imageUrl);
          if (!isMini) {
            if (
              type > 0 &&
              this.imageUpdateParams.templateDetailList != null &&
              this.imageUpdateParams.templateDetailList.length > 0
            ) {
              let imgObj = this.imageUpdateParams.templateDetailList.find(
                (x) => x.id === type
              );
              if (!imgObj.imgList) {
                imgObj.imgList = [];
              }
              imgObj.imgList.push(obj);
              // 支持多张图片，用逗号分隔
              if (imgObj.url && imgObj.url !== "") {
                imgObj.url = imgObj.url + "," + imgUrl;
              } else {
                imgObj.url = imgUrl;
              }
            } else if (type === -1) {
              //其他图片
              this.imageUpdateParams.reserve1List.push(obj);
            } else if (type === -2) {
              //免责图
              this.imageUpdateParams.reserve3List.push(obj);
            } else if (type === -3) {
              //勘测确认单
              this.imageUpdateParams.surveyImageList.push(obj);
            } else if (type === -99) {
              //视频
              this.imageUpdateParams.videoList = [];
              this.imageUpdateParams.videoList.push(obj);
              this.imageUpdateParams.videoUrl = imgUrl;
            }
          } else {
            this.setMiniImage(imgUrl, type);
          }
        })
        .catch((e) => {
          console.log(e);
          this.$message.error("上传失败");
        });
    },
    commRemove(file, fileList, type) {
      if (
        type > 0 &&
        this.imageUpdateParams.templateDetailList != null &&
        this.imageUpdateParams.templateDetailList.length > 0
      ) {
        let imgObj = this.imageUpdateParams.templateDetailList.find((x) => x.id === type);
        if (imgObj) {
          // 找到要删除的图片索引
          let index = -1;
          if (imgObj.imgList) {
            for (let i = 0; i < imgObj.imgList.length; i++) {
              if (imgObj.imgList[i].name === file.name || imgObj.imgList[i].url === file.url) {
                index = i;
                break;
              }
            }
          }
          
          if (index >= 0) {
            imgObj.imgList.splice(index, 1);
            // 更新URL和miniUrl，移除对应的URL
            let urls = imgObj.url ? imgObj.url.split(",") : [];
            let miniUrls = imgObj.miniUrl ? imgObj.miniUrl.split(",") : [];
            if (urls.length > index) {
              urls.splice(index, 1);
              imgObj.url = urls.join(",");
            }
            if (miniUrls.length > index) {
              miniUrls.splice(index, 1);
              imgObj.miniUrl = miniUrls.join(",");
            }
          }
        }
      } else if (type === -1) {
        //其他图片
        let j = 0;
        for (let i = 0; i < this.imageUpdateParams.reserve1List.length; i++) {
          if (file.name === this.imageUpdateParams.reserve1List[i].name) {
            j = i;
          }
        }
        this.imageUpdateParams.reserve1List.splice(j, 1);
      } else if (type === -2) {
        //免责图
        let j = 0;
        for (let i = 0; i < this.imageUpdateParams.reserve3List.length; i++) {
          if (file.name === this.imageUpdateParams.reserve3List[i].name) {
            j = i;
          }
        }
        this.imageUpdateParams.reserve3List.splice(j, 1);
      } else if (type === -3) {
        //勘测图
        let j = 0;
        for (let i = 0; i < this.imageUpdateParams.surveyImageList.length; i++) {
          if (file.name === this.imageUpdateParams.surveyImageList[i].name) {
            j = i;
          }
        }
        this.imageUpdateParams.surveyImageList.splice(j, 1);
      } else if (type === -99) {
        //视频
        this.imageUpdateParams.videoList = [];
        this.imageUpdateParams.videoUrl = null;
      }
    },
    setMiniImage(miniImgUrl, type) {
      //压缩图片
      let miniImageObj = {};
      miniImageObj.url = this.changeImageUrl(miniImgUrl);
      if (type <= 0) {
        return;
      } else {
        //模板图片
        if (
          this.imageUpdateParams.templateDetailList != null &&
          this.imageUpdateParams.templateDetailList.length > 0
        ) {
          let image = this.imageUpdateParams.templateDetailList.find(
            (x) => x.id === type
          );
          // 支持多张图片，用逗号分隔
          if (image.miniUrl && image.miniUrl !== "") {
            image.miniUrl = image.miniUrl + "," + miniImgUrl;
          } else {
            image.miniUrl = miniImgUrl;
          }
        }
      }
    },
    /**
     * 压缩图片
     * @param file
     * @returns {Promise<unknown>}
     */
    compressFile(file, quality) {
      return new Promise((resolve, reject) => {
        new ImageCompressor(file, {
          quality: quality, //压缩质量
          checkOrientation: false, //图片翻转，默认为false
          success(result) {
            resolve(result);
          },
          error(e) {
            reject(e);
          },
        });
      });
    },
    updateMaterial(index) {
      this.$set(this.isEdit, index, true);
    },
    updateMaterialSumbit(scoop) {
      this.axios({
        method: "post",
        url: "/v1/web/order-info/edit-material/" + this.tableData.id,
        data: scoop.row,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({ message: "修改成功", type: "success" });
          this.queryDetailList();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
      this.$set(this.isEdit, scoop.$index, false);
    },
    calcTotal(row) {
      row.allPrice = row.meterialPrice * row.num;
      row.actualAmount = row.allPrice;
    },
    addFollow() {
      this.followArr.orderId = this.orderId;
      this.dialogFollowAdd = true;
    },
    queryFollowList() {
      //获取跟进列表
      this.axios({
        method: "get",
        //后端接口
        url: "/v1/web/order-info/get-order-all-follow/" + this.orderId,
      }).then((res) => {
        this.modelTableData = res.data.data;
      });
    },
    addFollowSubMit() {
      this.axios({
        method: "post",
        url: "/v1/web/order-info/add-follow",
        data: this.followArr,
      }).then((res) => {
        if (res.data.code === 200) {
          this.dialogFollowAdd = false;
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.queryFollowList();
          this.getOrderCount();
          this.queryOrderList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 解绑充电桩（清空当前订单的充电桩相关信息）
    unbindDevice() {
      this.$confirm("确认解绑当前充电桩并清空充电桩详情吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios({
            method: "post",
            url: `/v1/web/order-info/unbind-device/${this.tableData.id}`,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({ message: "解绑成功", type: "success" });
              this.queryDetailList();
            } else {
              this.$message.error(res.data.message || "解绑失败");
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
// 全局样式，用于影响挂载到 body 下的对话框
.image-preview-dialog {
  background: rgba(0, 0, 0, 0.45) !important;
  z-index: 99;

  .el-dialog__body {
    padding: 12px 16px 16px !important;
  }

  .el-dialog__header {
    padding: 10px 16px 0;
  }

  .el-dialog__headerbtn {
    top: 14px;
    z-index: 3;
    right: 14px;
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: background-color 0.2s, transform 0.2s;

    &:hover {
      background: #fff;
      transform: scale(1.05);
    }
  }
}

.image-preview-boundary-message {
  min-width: auto !important;
  padding: 10px 18px !important;
  background: rgba(58, 61, 68, 0.94) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 6px !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22) !important;

  .el-message__icon {
    margin-right: 8px;
    color: rgba(255, 255, 255, 0.42) !important;
  }

  .el-message__content {
    color: rgba(255, 255, 255, 0.72) !important;
    font-size: 13px;
    line-height: 1.4;
  }
}
</style>
<style lang="scss" scoped>
.avatar {
  width: 300px;
  height: 178px;
  display: block;
}

.el-table {
  overflow: visible !important;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.custom-date-picker {
  width: 200px;
  height: 30px;
  font-size: 15px;
  padding-bottom: 0px;
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.install-time-text span {
  font-size: 12px;
}

@mixin preview-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.28) transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.28);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.42);
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

@mixin preview-panel-surface {
  background: rgba(18, 22, 30, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.image-preview-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: calc(100vh - 40px);
  min-height: 0;
}

.image-preview-top-bar {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: calc(100% - 120px);
  padding: 6px 14px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.32);
  pointer-events: none;
}

.image-preview-type-title {
  min-width: 0;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-preview-counter {
  flex-shrink: 0;
  padding-left: 10px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  white-space: nowrap;
}

.image-preview-layout {
  display: flex;
  gap: 10px;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.image-preview-left {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 10px;
  overflow: hidden;
  padding: 12px;
  @include preview-panel-surface;
}

.image-preview-stage {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.image-preview-container {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
  text-align: center;
  cursor: move;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.35);
}

.image-preview-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s, border-color 0.2s;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-50%) scale(1.06);
  }
}

.image-preview-nav-btn i {
  font-size: 20px;
  line-height: 1;
}

.image-preview-nav-btn--prev {
  left: 16px;
}

.image-preview-nav-btn--next {
  right: 16px;
}

.image-preview-zoom-toolbar {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px;
  border-radius: 24px;
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.image-preview-tool-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
    transform: scale(1.06);
  }
}

.image-preview-tool-btn--rotate {
  font-size: 12px;
}

.image-preview-tool-btn--reset {
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0;
}

.image-preview-thumbnails {
  flex-shrink: 0;
  width: 108px;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 6px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.28);
  opacity: 0.92;
  @include preview-scrollbar;
}

.image-preview-thumbnails-track {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
}

.image-preview-thumbnail-item {
  margin: 0;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 6px;
  overflow: hidden;
  opacity: 0.5;
  flex-shrink: 0;
  background: rgba(0, 0, 0, 0.35);
  transition: opacity 0.5s ease, border-color 0.5s ease;

  &:hover {
    opacity: 0.68;
  }
}

.image-preview-thumbnail-item.is-active {
  opacity: 0.86;
  border-color: rgba(255, 255, 255, 0.28);

  .image-preview-thumbnail-type {
    color: rgba(255, 255, 255, 0.92);
    font-weight: 500;
  }

  .image-preview-thumbnail-index {
    color: rgba(255, 255, 255, 0.62);
  }
}

.image-preview-thumbnail-img {
  width: 92px;
  height: 72px;
  object-fit: cover;
  display: block;
}

.image-preview-thumbnail-meta {
  padding: 4px 6px 6px;
  text-align: center;
  line-height: 1.3;
}

.image-preview-thumbnail-type {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-preview-thumbnail-index {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.65);
}

.image-preview-sidebar {
  flex-shrink: 0;
  min-width: 300px;
  max-width: 360px;
  width: 32%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px;
  @include preview-panel-surface;
  @include preview-scrollbar;
}

.order-info-container {
  padding: 12px 14px 16px;
  color: #fff;
}

.order-info-content {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.order-info-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: background-color 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
}

.order-info-item:last-child {
  border-bottom: none;
}

.order-info-label::after {
  content: "：";
}

.order-info-label {
  min-width: 100px;
  max-width: 110px;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.75);
  margin-right: 10px;
  flex-shrink: 0;
}

.order-info-value {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
  word-break: break-word;
}

.order-info-value--wrap {
  word-break: break-all;
  white-space: normal;
}
</style>
